import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'actions-menu.more-actions': {
    id: 'actions-menu.more-actions',
    defaultMessage: 'More actions',
    description: 'The aria label for the more actions dropdown button.',
  },
  'actions-menu.open-in-new-tab': {
    id: 'actions-menu.open-in-new-tab',
    defaultMessage: 'Open in a new tab',
    description: 'The text for an action menu button to open the database in a new tab.',
  },
  'actions-menu.copy-link': {
    id: 'actions-menu.copy-link',
    defaultMessage: 'Copy link',
    description: 'The text for an action menu button to copy the link to the database.',
  },
  'actions-menu.undo': {
    id: 'actions-menu.undo',
    defaultMessage: 'Undo',
    description: 'The text for an action menu button to undo the last action.',
  },
  'actions-menu.redo': {
    id: 'actions-menu.redo',
    defaultMessage: 'Redo',
    description: 'The text for an action menu button redo the last action.',
  },
  'actions-menu.lock-structure': {
    id: 'actions-menu.lock-structure',
    defaultMessage: 'Lock structure',
    description:
      'The text for an action menu button that locks the structure of a database.',
  },
  'actions-menu.lock-structure-tooltip': {
    id: 'actions-menu.lock-structure-tooltip',
    defaultMessage: 'Lock changes to fields in this database',
    description:
      'The tooltip text for the action menu item that locks the structure of a database',
  },
  'actions-menu.duplicate-structure': {
    id: 'actions-menu.duplicate-structure',
    defaultMessage: 'Duplicate structure',
    description:
      'The text for an action menu button that copies the structure of a database.',
  },
  'actions-menu.make-a-copy-structure': {
    id: 'actions-menu.make-a-copy-structure',
    defaultMessage: 'Make a copy of structure',
    description:
      'The text for an action menu button that makes a copy of the structure of a database.',
  },
  'actions-menu.import-and-templates': {
    id: 'actions-menu.import-and-templates',
    defaultMessage: 'Templates and import',
    description:
      'The text for an action menu button to open up the setup panel for Databases.',
  },
  'actions-menu.export': {
    id: 'actions-menu.export',
    defaultMessage: 'Export',
    description: 'The text for an action menu button to export a database.',
  },
  'actions-menu.get-help': {
    id: 'actions-menu.get-help',
    defaultMessage: 'Get help',
    description: 'The text for an action menu button that directs to a help page.',
  },
  'actions-menu.devtools': {
    id: 'actions-menu.devtools',
    defaultMessage: 'Devtools',
    description: 'The text for an action menu button that opens developer tools.',
  },
  'actions-menu.permissions': {
    id: 'actions-menu.permissions',
    defaultMessage: 'Permissions',
    description:
      'The text for an action menu button that directs to database permissions.',
  },
  'actions-menu.mac-undo-shortcut': {
    id: 'actions-menu.mac-undo-shortcut',
    defaultMessage: '⌘Z',
    description: 'Mac keyboard shortcut to undo an action.',
  },
  'actions-menu.non-mac-undo-shortcut': {
    id: 'actions-menu.non-mac-undo-shortcut',
    defaultMessage: 'Ctrl + Z',
    description: 'Non Mac (eg Windows, linux etc) keyboard shortcut to undo an action.',
  },
  'actions-menu.mac-redo-shortcut': {
    id: 'actions-menu.mac-redo-shortcut',
    defaultMessage: '⌘⇧Z',
    description: 'Mac keyboard shortcut to redo an action.',
  },
  'actions-menu.non-mac-redo-shortcut': {
    id: 'actions-menu.non-mac-redo-shortcut',
    defaultMessage: 'Ctrl + Shift + Z',
    description: 'Non Mac (eg Windows, linux etc) keyboard shortcut to redo an action.',
  },
  'board-layout.default-select-option-done': {
    id: 'board-layout.default-select-option-done',
    defaultMessage: 'Done',
    description:
      'The default select option label for the third column when auto-creating a tag field for a board view.',
  },
  'board-layout.default-select-option-in-progress': {
    id: 'board-layout.default-select-option-in-progress',
    defaultMessage: 'In progress',
    description:
      'The default select option label for the second column when auto-creating a tag field for a board view.',
  },
  'board-layout.default-select-option-not-started': {
    id: 'board-layout.default-select-option-not-started',
    defaultMessage: 'Not started',
    description:
      'The default select option label for the first column when auto-creating a tag field for a board view.',
  },
  'board-layout.default-tag-label': {
    id: 'board-layout.default-tag-label',
    defaultMessage: 'Tag {number}',
    description: 'The default tag label for new tags created.',
  },
  'board-layout.empty-tag-label': {
    id: 'board-layout.empty-tag-label',
    defaultMessage: 'No tag',
    description:
      'The name of the column on the Board layout when grouped by Tag field that does not contain any value.',
  },
  'board-layout.empty-state-heading': {
    id: 'board-layout.empty-state-heading',
    defaultMessage: 'Missing tag field',
    description: 'The heading text for the empty state for the board layout.',
  },
  'board-layout.empty-state-group-by-heading': {
    id: 'board-layout.empty-state-group-by-heading',
    defaultMessage: 'No single-select fields available to group by.',
    description:
      'The heading text for the empty state for the board layout with grouping.',
  },
  'board-layout.empty-state-description': {
    id: 'board-layout.empty-state-description',
    defaultMessage:
      'Boards are organized with tags. Add a tag field to use the board view.',
    description: 'The description text for the empty state for the board layout.',
  },
  'board-layout.empty-state-group-by-description': {
    id: 'board-layout.empty-state-group-by-description',
    defaultMessage:
      'Switch a field to single-select or add a new one to use grouping on this view.',
    description:
      'The description text for the empty state for the board layout with grouping.',
  },
  'board-layout.empty-state-button-text': {
    id: 'board-layout.empty-state-button-text',
    defaultMessage: 'Add tag field',
    description: 'The button text for the empty state for the board layout.',
  },
  'board-layout.empty-state-group-by-button-text': {
    id: 'board-layout.empty-state-group-by-button-text',
    defaultMessage: 'Add field to group by',
    description:
      'The button text for the empty state for the board layout with grouping.',
  },
  'board-layout.collapse-label': {
    id: 'board-layout.collapse-label',
    defaultMessage: 'Collapse',
    description: 'The label text for collapse subgroup.',
  },
  'board-layout.expand-label': {
    id: 'board-layout.expand-label',
    defaultMessage: 'Expand',
    description: 'The label text for expand subgroup.',
  },
  'calendar-layout.empty-state-heading': {
    id: 'calendar-layout.empty-state-heading',
    defaultMessage: 'Missing date field',
    description: 'The heading text for the empty state for the calendar layout.',
  },
  'calendar-layout.empty-state-description': {
    id: 'calendar-layout.empty-state-description',
    defaultMessage:
      'Calendars are organized by date. Add a date field to use the calendar view.',
    description: 'The description text for the empty state for the calendar layout.',
  },
  'calendar-layout.empty-state-button-text': {
    id: 'calendar-layout.empty-state-button-text',
    defaultMessage: 'Add date field',
    description: 'The button text for the empty state for the calendar layout.',
  },
  'close-label': {
    id: 'close-label',
    defaultMessage: 'Close',
    description: 'The label text associated with the close button icon.',
  },
  'color-picker.options-container': {
    id: 'color-picker.options-container',
    defaultMessage: 'Selectable colors',
    description: 'The label text associated with the color picker selectable colors.',
  },
  'color-picker.selected-label': {
    id: 'color-picker.selected-label',
    defaultMessage: 'Selected',
    description: 'The label text associated with the color picker selected checkbox.',
  },
  'copy-database-dialog.description.duplicate-exp': {
    id: 'copy-database-dialog.description.duplicate-exp',
    defaultMessage:
      'Name the duplicated database and pick a space for the location. Note that only the structure (field setup) of your database will be duplicated over. Values will not be duplicated',
    description: 'The description text for the copy database dialog.',
  },
  'copy-database-dialog.description.make-a-copy-exp': {
    id: 'copy-database-dialog.description.make-a-copy-exp',
    defaultMessage:
      'Name the copied database and pick a space for the location. Note that only the structure (field setup) of your database will be copied over. Values will not be copied',
    description: 'The description text for the copy database dialog.',
  },
  'copy-database-dialog.name-label': {
    id: 'copy-database-dialog.name-label',
    defaultMessage: 'Name',
    description: 'The label for the database Name field.',
  },
  'copy-database-dialog.space-label': {
    id: 'copy-database-dialog.space-label',
    defaultMessage: 'Space',
    description: 'The label for the database Space field.',
  },
  'copy-database-dialog.heading.duplicate-exp': {
    id: 'copy-database-dialog.heading.duplicate-exp',
    defaultMessage: 'Duplicate database structure',
    description: 'The heading for the copy database dialog.',
  },
  'copy-database-dialog.heading.make-a-copy-exp': {
    id: 'copy-database-dialog.heading.make-a-copy-exp',
    defaultMessage: 'Make a copy of database structure',
    description: 'The heading for the copy database dialog.',
  },
  'copy-database-dialog.duplicate-button': {
    id: 'copy-database-dialog.duplicate-button',
    defaultMessage: 'Duplicate',
    description:
      'The button text for the Duplicate button. Clicking this opens a submenu.',
  },
  'copy-database-dialog.make-a-copy-button': {
    id: 'copy-database-dialog.make-a-copy-button',
    defaultMessage: 'Make a copy',
    description:
      'The button text for the Make a copy button. Clicking this opens a submenu.',
  },
  'copy-database-dialog.new-database-name-with-suffix.duplicate-exp': {
    id: 'copy-database-dialog.new-database-name-with-suffix.duplicate-exp',
    defaultMessage: '{databaseName} duplicate',
    description: 'The default name for the duplicated database.',
  },
  'copy-database-dialog.new-database-name-with-suffix.make-a-copy-exp': {
    id: 'copy-database-dialog.new-database-name-with-suffix.make-a-copy-exp',
    defaultMessage: '{databaseName} copy',
    description: 'The default name for the copied database.',
  },
  'copy-link.label': {
    id: 'copy-link.label',
    defaultMessage: 'Copy link',
    description: 'The label for the copy button icon',
  },
  'copy-link.tooltip': {
    id: 'copy-link.tooltip',
    defaultMessage: 'Copied!',
    description:
      'The tooltip that shows up after a user clicks on the copy button to indicate the content has been successfully copied.',
  },
  'embed-view.error-description-text': {
    id: 'embed-view.error-description-text',
    defaultMessage:
      'We couldn’t find the link. Check the url and try editing or paste again.',
    description: 'The description text for the embed value view error message.',
  },
  'embed-view.error-heading-text': {
    id: 'embed-view.error-heading-text',
    defaultMessage: 'We couldn’t load this link for an unknown reason.',
    description: 'The heading text for the embed value view error message.',
  },
  'embed-view.error-cant-find-link-heading-text': {
    id: 'embed-view.error-cant-find-link-heading-text',
    defaultMessage: 'Uh oh. We can’t find the link!',
    description: 'The heading text for the embed value view error message.',
  },
  'embed-view.try-again-button-text': {
    id: 'embed-view.try-again-button-text',
    defaultMessage: 'Try again',
    description: 'The button text for the embed value view error message.',
  },
  'entry-actions.delete-button-text': {
    id: 'entry-actions.delete-button-text',
    defaultMessage: 'Delete',
    description: 'The button text to delete an entry.',
  },
  'entry-actions.print-button-text': {
    id: 'entry-actions.print-button-text',
    defaultMessage: 'Print',
    description: 'The button text to print an entry.',
  },
  'entry-actions.cancel-button-text': {
    id: 'entry-actions.cancel-button-text',
    defaultMessage: 'Cancel',
    description: 'The button text to cancel.',
  },
  'entry-actions.delete-entry-heading-text': {
    id: 'entry-actions.delete-entry-heading-text',
    defaultMessage: 'Delete entry',
    description: 'The heading text for the delete entry confirm dialog.',
  },
  'entry-actions.delete-entry-body-text': {
    id: 'entry-actions.delete-entry-body-text',
    defaultMessage:
      'Are you sure you want to delete the entry <strong>{entryName}</strong> from the database?',
    description: 'The body text for the delete entry confirm dialog.',
  },
  'create-entry-panel.header.title': {
    id: 'create-entry-panel.header.title',
    defaultMessage: 'Add entry',
    description: 'The title text for the create entry panel.',
  },
  'entry-card.add-entry-text': {
    id: 'entry-card.add-entry-text',
    defaultMessage: 'Add entry',
    description: 'The text associated with the add entry button in gallery layout.',
  },
  'entry-dialog.heading': {
    id: 'entry-dialog.heading',
    defaultMessage: 'Database entry',
    description: 'The heading text that is shown at the top of the entry dialog.',
  },
  'broken-link.broken-link-text': {
    id: 'broken-link.broken-link-text',
    defaultMessage: 'Can’t find link',
    description: 'The text associated with the broken entry link error message.',
  },
  'restricted-link.restricted-link-text': {
    id: 'restricted-link.restricted-link-text',
    defaultMessage: 'Restricted link',
    description: 'The text associated with the restricted entry link error message.',
  },
  'entry-link.no-options': {
    id: 'entry-link.no-options',
    defaultMessage: 'Please configure a database in the field settings.',
    description:
      'The helper text that displays under the default value select dropdown in the entry link field setting when no database has been selected yet.',
  },
  'entry-picker.validate-error-text': {
    id: 'entry-picker.validate-error-text',
    defaultMessage: 'Please select an entry.',
    description: 'The text associated with the entry picker option to add a new entry.',
  },
  'entry-right-rail.delete-entry': {
    id: 'entry-right-rail.delete-entry',
    defaultMessage: 'Delete entry',
    description: 'The tooltip on the trashcan icon for deleting an entry.',
  },
  'entry.add-field-button': {
    id: 'entry.add-field-button',
    defaultMessage: 'Add field',
    description: 'The button text for the entry add field button.',
  },
  'error-message.could-not-find-entry': {
    id: 'error-message.could-not-find-entry',
    defaultMessage: 'Could not find database entry {entryId}.',
    description:
      'The error message shown when a database entry could not be found and the app crashes.',
  },
  'error-message.could-not-find-field': {
    id: 'error-message.could-not-find-field',
    defaultMessage: 'Could not find database field {fieldId}.',
    description:
      'The error message shown when a database field could not be found and the app crashes.',
  },
  'error-message.unknown-field-type': {
    id: 'error-message.unknown-field-type',
    defaultMessage: 'Unknown field type ${fieldType}.',
    description:
      'The error message shown when a database contains a field type that is not supported.',
  },
  'field-settings.heading': {
    id: 'field-settings.heading',
    defaultMessage: 'Field settings',
    description: 'The heading for the field setting right side panel.',
  },
  'field-settings.field-name': {
    id: 'field-settings.field-name',
    defaultMessage: 'Field Name',
    description: 'The label text for the create field field name.',
  },
  'field-settings.field-name-placeholder': {
    id: 'field-settings.field-name-placeholder',
    defaultMessage: 'Name your field',
    description: 'The placeholder text for an unnamed field.',
  },
  'field-settings.type': {
    id: 'field-settings.type',
    defaultMessage: 'Field type',
    description: 'The label associated with the field type dropdown.',
  },
  'field-settings.default-value': {
    id: 'field-settings.default-value',
    defaultMessage: 'Apply default value',
    description:
      'Label that will show next to a toggle that allows the user to determine if a default value should be applied to new entries.',
  },
  'field-settings.default-value.label': {
    id: 'field-settings.default-value.label',
    defaultMessage: 'Default value',
    description:
      'If the user has the default value toggle enabled, this label will be associated with the input field that allows the user to enter a default value. It is not actually shown in the UI but will be used by screen readers.',
  },
  'field-settings.edit-options': {
    id: 'field-settings.edit-options',
    defaultMessage: 'Edit options',
    description:
      'The label associated with edit options within the field settings right side panel.',
  },
  'field-settings.allow-line-breaks': {
    id: 'field-settings.allow-line-breaks',
    defaultMessage: 'Allow line breaks',
    description:
      'The label associated with the checkbox to allow line breaks in the field settings right side panel.',
  },
  'field-settings.field-description': {
    id: 'field-settings.field-description',
    defaultMessage: 'Add field description',
    description:
      'Label that will show next to a toggle that allows the user to determine if a field should have a description.',
  },
  'field-settings.field-description.label': {
    id: 'field-settings.field-description.label',
    defaultMessage: 'Field description',
    description:
      'If the user has the field description toggle enabled, this label will be associated with the input field that allows the user to enter a description for the field. It is not actually shown in the UI but will be used by screen readers.',
  },
  'field-settings.field-description-placeholder': {
    id: 'field-settings.field-description-placeholder',
    defaultMessage: 'Add description here...',
    description: 'The placeholder text for the field description text box.',
  },
  'field-settings.field-description-helper-message': {
    id: 'field-settings.field-description-helper-message',
    defaultMessage: 'Description appears on hover of field header',
    description: 'The helper text for the field description text box.',
  },
  'field-settings.field-default-value-helper-message': {
    id: 'field-settings.field-default-value-helper-message',
    defaultMessage: 'This default value will only apply to new entries',
    description: 'This default value will only apply to new entries',
  },
  'field-settings.date-default-value': {
    id: 'field-settings.date-default-value',
    defaultMessage: 'Set current date as default value',
    description:
      'The label for the checkbox associated with setting the current date as the default value.',
  },
  'field-settings.date-and-time-picker-label': {
    id: 'field-settings.date-and-time-picker-label',
    defaultMessage: 'Date and time',
    description:
      'Accessible label for the date-time picker when no specific aria label is provided.',
  },
  'field-settings.date-default-value-with-time': {
    id: 'field-settings.date-default-value-with-time',
    defaultMessage: 'Set current date and time as default value',
    description:
      'The label for the checkbox when the date field includes time; the default value stores the current instant.',
  },
  'field-settings.type-number-format': {
    id: 'field-settings.type-number-format',
    defaultMessage: 'Format',
    description: 'The label for the format number dropdown.',
  },
  'field-settings.type-number-whitespace-text': {
    id: 'field-settings.type-number-whitespace-text',
    defaultMessage: 'Whitespace',
    description: 'The label for the whitespace option in the number dropdown.',
  },
  'field-settings.type-number-dot-text': {
    id: 'field-settings.type-number-dot-text',
    defaultMessage: 'Dot',
    description: 'The label for the dot option in the number dropdown.',
  },
  'field-settings.type-number-no-format': {
    id: 'field-settings.type-number-no-format',
    defaultMessage: 'No formatting',
    description: 'The label for the no format option in the number dropdwon.',
  },
  'field-settings.type-number-comma-text': {
    id: 'field-settings.type-number-comma-text',
    defaultMessage: 'Comma',
    description: 'The label for the comma option in the number dropdown.',
  },
  'field-settings.type-number-apostrophe-text': {
    id: 'field-settings.type-number-apostrophe-text',
    defaultMessage: 'Apostrophe',
    description: 'The label for the apostrophe option in the number dropdown.',
  },
  'field-settings.type-page-link-create-page-text': {
    id: 'field-settings.type-page-link-create-page-text',
    defaultMessage: 'Create page <strong>{title}</strong>',
    description: 'The text for creating a new page in the page link dropdown.',
  },
  'field-settings.type-page-link-create-live-doc-text': {
    id: 'field-settings.type-page-link-create-live-doc-text',
    defaultMessage: 'Create live doc <strong>{title}</strong>',
    description: 'The text for creating a new live doc in the page link dropdown.',
  },
  'field-settings.type-page-label-create-label-text': {
    id: 'field-settings.type-page-label-create-label-text',
    defaultMessage: 'Create <strong>{query}</strong>',
    description: 'The text for creating a new page label in the page label dropdown.',
  },
  'field-settings.type-page-link-create-under-text': {
    id: 'field-settings.type-page-link-create-under-text',
    defaultMessage: 'Create under <strong>{page}</strong>',
    description:
      'The text for creating a new page under a parent page in the page link dropdown.',
  },
  'field-settings.type-page-link-create-inline-error': {
    id: 'field-settings.type-page-link-create-inline-error',
    defaultMessage: 'Can’t create in the current location',
    description:
      'The generic error message displayed inline in the page picker when a page cannot be created and the create option is disabled.',
  },
  'field-settings.type-page-link-create-inline-error.no-parent-item': {
    id: 'field-settings.type-page-link-create-inline-error.no-parent-item',
    defaultMessage: 'Select a parent item in field settings to create',
    description:
      'The error message displayed inline in the page picker when a page cannot be created due to no parent item being selected in field settings.',
  },
  'field-settings.type-page-link-create-in-context-error': {
    id: 'field-settings.type-page-link-create-in-context-error',
    defaultMessage:
      'We couldn’t create the page. Try checking the parent item or your permissions.',
    description:
      'The error message displayed on top of the page picker when a page cannot be created after selecting the create option.',
  },
  'field-settings.type-page-link-live-doc-create-in-context-error': {
    id: 'field-settings.type-page-link-live-doc-create-in-context-error',
    defaultMessage:
      'We couldn’t create the live doc. Try checking the parent item or your permissions.',
    description:
      'The error message displayed on top of the page picker when a live doc cannot be created after selecting the create option.',
  },
  'field-settings.type-page-label-label-create-error': {
    id: 'field-settings.type-page-label-label-create-error',
    defaultMessage: 'Label contains invalid character(s)',
    description:
      'The error message displayed on top of the page label picker when a page label failed to be created after selecting the create option',
  },
  'field-settings.type-page-link-add-page': {
    id: 'field-settings.type-page-link-add-page',
    defaultMessage: 'Add page',
    description:
      'The text for selecting a new page in the page link dropdown (multi-select).',
  },
  'field-settings.type-page-link-add-live-doc': {
    id: 'field-settings.type-page-link-add-live-doc',
    defaultMessage: 'Add live doc',
    description:
      'The text for selecting a new live doc in the page link dropdown (multi-select).',
  },
  'field-settings.type-page-link-viewed-text': {
    id: 'field-settings.type-page-link-viewed-text',
    defaultMessage: 'Viewed {timeSinceLastViewed}',
    description:
      'The text for creating a new page under a parent page in the page link dropdown.',
  },
  'field-settings.type-page-link-label': {
    id: 'field-settings.type-page-link-label',
    defaultMessage: 'Format',
    description: 'The label for the format number dropdown.',
  },
  'field-settings.type-page-link-parent-item': {
    id: 'field-settings.type-page-link-parent-item',
    defaultMessage: 'Parent item',
    description:
      'The label for the select parent item section in the page link field settings.',
  },
  'field-settings.type-page-link-sub-type-live-doc': {
    id: 'field-settings.type-page-link-sub-type-live-doc',
    defaultMessage: 'Live doc',
    description:
      'The label for the live doc sub type option in the page link field settings.',
  },
  'field-settings.type-page-link-sub-type-page': {
    id: 'field-settings.type-page-link-sub-type-page',
    defaultMessage: 'Page',
    description: 'The label for the page subtype option in the page link field settings.',
  },
  'field-settings.type-page-link-location-fixed': {
    id: 'field-settings.type-page-link-location-fixed',
    defaultMessage: 'Fixed',
    description:
      'The label for the fixed location option in the page link field settings.',
  },
  'field-settings.type-page-link-location-dynamic': {
    id: 'field-settings.type-page-link-location-dynamic',
    defaultMessage: 'Dynamic',
    description:
      'The label for the dynamic location option in the page link field settings.',
  },
  'field-settings.type-page-link-parent-item-error-message': {
    id: 'field-settings.type-page-link-parent-item-error-message',
    defaultMessage: 'Parent item is required',
    description:
      'The error message for the parent item dropdown in the field settings panel for page link fields.',
  },
  'field-settings.type-page-link-parent-item-placeholder': {
    id: 'field-settings.type-page-link-parent-item-placeholder',
    defaultMessage: 'Select parent item...',
    description:
      'The placeholder text for the parent item dropdown in the field settings panel for page link fields.',
  },
  'field.settings.page-link.page-template': {
    id: 'field.settings.page-link.page-template',
    defaultMessage: 'Page template (optional)',
    description:
      'The label for the page template dropdown in the field settings panel for page link fields.',
  },
  'field.settings.page-link.template': {
    id: 'field.settings.page-link.template',
    defaultMessage: 'Template (optional)',
    description:
      'The label for the template dropdown in the field settings panel for page link fields.',
  },
  'field.settings.page-link.page-template-placeholder': {
    id: 'field.settings.page-link.page-template-placeholder',
    defaultMessage: 'Select template...',
    description:
      'The placeholder text for the page template dropdown in the field settings panel for page link fields.',
  },
  'field.settings.display-entry-on-page-label': {
    id: 'field.settings.display-entry-on-page-label',
    defaultMessage: 'Display entry on created pages',
    description:
      'The label for the display entry on page checkbox in the field settings panel for page link fields.',
  },
  'field.settings.display-entry-on-page-and-live-doc-label': {
    id: 'field.settings.display-entry-on-page-and-live-doc-label',
    defaultMessage: 'Display entry on created pages and live docs',
    description:
      'The label for the display entry on page and live doc checkbox in the field settings panel for page link fields.',
  },
  'field-settings.type-page-status-picker-create-text': {
    id: 'field-settings.type-page-status-picker-create-text',
    defaultMessage: 'Create',
    description: 'The text associated with the page status picker create option.',
  },
  'field-settings.type-page-status-picker-new-text': {
    id: 'field-settings.type-page-status-picker-new-text',
    defaultMessage: '(new)',
    description: 'The text associated with the page status picker (new) option.',
  },
  'field-settings.type-page-status-picker-custom-statuses-text': {
    id: 'field-settings.type-page-status-picker-custom-statuses-text',
    defaultMessage: 'Custom statuses',
    description:
      'The label text associated with the page status picker Custom Statuses option.',
  },
  'field-settings.type-page-status-picker-default-workflow-text': {
    id: 'field-settings.type-page-status-picker-default-workflow-text',
    defaultMessage: 'Default workflow',
    description:
      'The label text associated with the page status picker Default Workflow option.',
  },
  'field-settings.type-tag-selectable-items': {
    id: 'field-settings.type-tag-selectable-items',
    defaultMessage: 'Selectable items',
    description: 'The label for the list of selectable tags in the field settings panel.',
  },
  'field-settings.type-tag-duplicate-items': {
    id: 'field-settings.type-tag-duplicate-items',
    defaultMessage: 'New duplicate items not allowed, value not saved',
    description: 'The label for the error of duplicate tags in the field settings panel.',
  },
  'field-settings.type-jira-issue-jira-instance': {
    id: 'field-settings.type-jira-issue-jira-instance',
    defaultMessage: 'Jira instance',
    description: 'The label associated with the dropdown to select a Jira instance',
  },
  'field-settings.type-jira-issue-jira-instance-placeholder': {
    id: 'field-settings.type-jira-issue-jira-instance-placeholder',
    defaultMessage: 'Using default Jira instance',
    description:
      'The placeholder text for the disabled Jira Instance dropdown under the Jira Issue field setting that hints at the user that the default jira instance is being used.',
  },
  'field-settings.type-jira-issue-jira-instance-tooltip': {
    id: 'field-settings.type-jira-issue-jira-instance-tooltip',
    defaultMessage:
      'Your Confluence instance does not support selecting a Jira instance. The Jira instance configured as the primary application link will be used.',
    description:
      'The tooltip for the disabled Jira Instance dropdown under the Jira Issue field setting that lets the user know the primary server is being used and the reason for it.',
  },
  'field-settings.database': {
    id: 'field-settings.database',
    defaultMessage: 'Database',
    description: 'The label associated with the dropdown to select a database.',
  },
  'field-settings.type-entry-details-entry-link': {
    id: 'field-settings.type-entry-details-entry-link',
    defaultMessage: 'Entry link',
    description: 'The label associated with the dropdown to select an entry link.',
  },
  'field-settings.type-entry-details-entry-value': {
    id: 'field-settings.type-entry-details-entry-value',
    defaultMessage: 'Entry value',
    description: 'The label associated with the dropdown to select an entry value.',
  },
  'field-settings.type-backlink-display': {
    id: 'field-settings.type-backlink-display',
    defaultMessage: 'Display as',
    description:
      'The label associated with the dropdown to display entry as a link or as a number.',
  },
  'field-settings.type-backlink-display-as-link': {
    id: 'field-settings.type-backlink-display-as-link',
    defaultMessage: 'Smart Link',
    description:
      'The dropdown option for displaying the back link field as a link to the database that this entry is linked to.',
  },
  'field-settings.type-backlink-display-as-number': {
    id: 'field-settings.type-backlink-display-as-number',
    defaultMessage: 'Number',
    description:
      'The dropdown option for displaying the back link field as the number of links from another database that an entry is linked to.',
  },
  'field-settings.type-page-label-page-link': {
    id: 'field-settings.type-page-label-page-link',
    defaultMessage: 'Page link field',
    description: 'The label associated with the dropdown to select a page link.',
  },
  'field-settings.type-page-label-link': {
    id: 'field-settings.type-page-label-link',
    defaultMessage: 'Link field',
    description: 'The label associated with the dropdown to select a page link.',
  },
  'field-settings.type-page-link-selector-placeholder': {
    id: 'field-settings.type-page-link-selector-placeholder',
    defaultMessage: 'Select a page link field...',
    description: 'The placeholder text for the page link field dropdown.',
  },
  'field-settings.type-page-and-live-doc-link-selector-placeholder': {
    id: 'field-settings.type-page-and-live-doc-link-selector-placeholder',
    defaultMessage: 'Select a page or doc link field...',
    description: 'The placeholder text for the page link field dropdown.',
  },
  'field-settings.type-page-label-enable-label-editing': {
    id: 'field-settings.type-page-label-enable-label-editing',
    defaultMessage: 'Enable label editing',
    description: 'The label associated with the checkbox to enable label editing.',
  },
  'field-settings.type-page-label-or-status-enable-editing-from-database': {
    id: 'field-settings.type-page-label-or-status-enable-editing-from-database',
    defaultMessage: 'Allow editing from database',
    description:
      'The label associated with the checkbox to enable page label or page status editing.',
  },
  'field-settings.type-page-status-page-link': {
    id: 'field-settings.type-page-status-page-link',
    defaultMessage: 'Page link',
    description: 'The label associated with the dropdown to select a page link.',
  },
  'field-settings.type-page-status-enable-status-editing': {
    id: 'field-settings.type-page-status-enable-status-editing',
    defaultMessage: 'Enable status editing',
    description: 'The label associated with the checkbox to enable status editing.',
  },
  'field-settings.type-page-details-page-link': {
    id: 'field-settings.type-page-details-page-link',
    defaultMessage: 'Page link',
    description: 'The label associated with the dropdown to select a page link.',
  },
  'field-settings.type-page-details-displayed-detail': {
    id: 'field-settings.type-page-details-displayed-detail',
    defaultMessage: 'Displayed detail',
    description:
      'The label associated with the dropdown to select the displayed page detail.',
  },
  'field-settings.type-page-details-detail-created-at': {
    id: 'field-settings.type-page-details-detail-created-at',
    defaultMessage: 'Created at',
    description:
      'One of the values for the display page detail dropdown that indicates the page property called created at.',
  },
  'field-settings.type-page-details-detail-created-by': {
    id: 'field-settings.type-page-details-detail-created-by',
    defaultMessage: 'Created by',
    description:
      'One of the values for the display page detail dropdown that indicates the page property called created by.',
  },
  'field-settings.type-page-details-detail-last-updated-at': {
    id: 'field-settings.type-page-details-detail-last-updated-at',
    defaultMessage: 'Last updated at',
    description:
      'One of the values for the display page detail dropdown that indicates the page property called last updated at.',
  },
  'field-settings.type-page-details-detail-last-updated-by': {
    id: 'field-settings.type-page-details-detail-last-updated-by',
    defaultMessage: 'Last updated by',
    description:
      'One of the values for the display page detail dropdown that indicates the page property called last updated by.',
  },
  'field-settings.type-page-details-detail-excerpt-content': {
    id: 'field-settings.type-page-details-detail-excerpt-content',
    defaultMessage: 'Excerpt content',
    description:
      'One of the values for the display page detail dropdown that indicates the page property called excerpt content.',
  },
  'field-settings.type-page-details-detail-version-number': {
    id: 'field-settings.type-page-details-detail-version-number',
    defaultMessage: 'Version number',
    description:
      'One of the values for the display page detail dropdown that indicates the page property called current version.',
  },
  'field-settings.type-jira-issue-details-jira-issue': {
    id: 'field-settings.type-jira-issue-details-jira-issue',
    defaultMessage: 'Jira issue',
    description: 'The label associated with the dropdown to select a Jira issues.',
  },
  'field-settings.type-jira-issue-details-jira-issue-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-details-jira-issue-issue-terminology-refresh-m4',
    defaultMessage: 'Jira work item',
    description: 'The label associated with the dropdown to select a Jira issues.',
  },
  'field-settings.type-jira-issue-details-jira-field': {
    id: 'field-settings.type-jira-field-details-jira-field',
    defaultMessage: 'Jira issue detail',
    description: 'The label associated with the dropdown to select a Jira field.',
  },
  'field-settings.type-jira-issue-details-jira-field-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-field-details-jira-field-issue-terminology-refresh-m4',
    defaultMessage: 'Jira work item detail',
    description: 'The label associated with the dropdown to select a Jira field.',
  },
  'field-settings.type-jira-issue-details-jira-field-description': {
    id: 'field-settings.type-jira-issue-details-jira-field-description',
    defaultMessage: 'Select from the list or type to find more options',
    description:
      'The helper text underneath the Jira Field dropdown in the Jira issue detail field setting that lets the user know how to interact with the dropdown.',
  },
  'field-settings.type-jira-issue-details-select-jira-field-placeholder': {
    id: 'field-settings.type-jira-issue-details-select-jira-field-placeholder',
    defaultMessage: 'Select a Jira detail...',
    description: 'The placeholder text for the Jira Field dropdown.',
  },
  'field-settings.type-user-enable-multi-select': {
    id: 'field-settings.type-user-enable-multi-select',
    defaultMessage: 'Allow multiple users',
    description:
      'The label associated with the checkbox to enable multi select for a user field.',
  },
  'field-settings.type-mentions-notifications-checkbox': {
    id: 'field-settings.type-mentions-notifications-checkbox',
    defaultMessage: 'Send notification to mentioned user',
    description:
      'The label associated with the checkbox to trigger notification to recipient.',
  },
  'field-settings.type-select-enable-multi-select': {
    id: 'field-settings.type-select-enable-multi-select',
    defaultMessage: 'Allow multiple tags',
    description:
      'The label associated with the checkbox to enable multi select for a tag field.',
  },
  'field-settings.type-hyperlink-enable-multi-select': {
    id: 'field-settings.type-hyperlink-enable-multi-select',
    defaultMessage: 'Allow multiple links',
    description:
      'The label associated with the checkbox to enable multi select for a hyperlink field.',
  },
  'field-settings.type-jira-issue-enable-multi-select': {
    id: 'field-settings.type-jira-issue-enable-multi-select',
    defaultMessage: 'Allow multiple Jira Issues',
    description:
      'The label associated with the checkbox to enable multi select for a jira issue field.',
  },
  'field-settings.type-jira-issue-enable-multi-select-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-enable-multi-select-issue-terminology-refresh-m4',
    defaultMessage: 'Allow multiple Jira work items',
    description:
      'The label associated with the checkbox to enable multi select for a jira issue field.',
  },
  'field-settings.type-page-link-enable-multi-select': {
    id: 'field-settings.type-page-link-enable-multi-select',
    defaultMessage: 'Allow multiple page links',
    description:
      'The label associated with the checkbox to enable multi select for a page link field.',
  },
  'field-settings.type-page-link-enable-multi-links': {
    id: 'field-settings.type-page-link-enable-multi-links',
    defaultMessage: 'Allow multiple links',
    description:
      'The label associated with the checkbox to enable multi links for a page link field.',
  },
  'field-settings.type-entry-link-enable-multi-select': {
    id: 'field-settings.type-entry-link-enable-multi-select',
    defaultMessage: 'Allow multiple entry links',
    description:
      'The label associated with the checkbox to enable multi select for a entry link field.',
  },
  'field-settings.type-user-add-user-label-text': {
    id: 'field-settings.type-user-add-user-label-text',
    defaultMessage: 'Add user',
    description:
      'The label text associated with the user picker list for the user field.',
  },
  'field-settings.type-user-set-current-user-default-text': {
    id: 'field-settings.type-user-set-current-user-default-text',
    defaultMessage: 'Set current user as default value',
    description:
      'The text associated with the checkbox to set the current user as the default value for the user field.',
  },
  'field-settings.tag-add-item': {
    id: 'field-settings.tag-add-item',
    defaultMessage: 'Add item',
    description: 'The label associated with the add item button.',
  },
  'field-settings.tag-delete': {
    id: 'field-settings.tag-delete',
    defaultMessage: 'Delete',
    description: 'The aria label associated with the delete tag button.',
  },
  'field-settings.toggle-page-creation': {
    id: 'field-settings.toggle-page-creation',
    defaultMessage: 'Page creation',
    description: 'The label associated with the toggle to enable page creation.',
  },
  'field-settings.checkbox-allow-tag-creation': {
    id: 'field-settings.checkbox-allow-tag-creation',
    defaultMessage: 'Allow tag creation',
    description: 'The label associated with the checkbox to allow tag creation.',
  },
  'field-settings.link-show-as-smart-link-text': {
    id: 'field-settings.link-show-as-smart-link-text',
    defaultMessage: 'Show as Smart Link',
    description:
      'The label associated with the checkbox to show the resolved link instead of the full URL',
  },
  'field-settings.change-field-dialog': {
    id: 'field-settings.change-field-dialog',
    defaultMessage:
      'Changing this field type may result in the loss of your values, field settings, and calculations.',
    description: 'The body text for the change field dialog.',
  },
  'field-settings.change-field-heading': {
    id: 'field-settings.change-field-heading',
    defaultMessage: 'Change field type?',
    description: 'The heading text for the change field dialog.',
  },
  'field-settings.change-field-button': {
    id: 'field-settings.change-field-button',
    defaultMessage: 'Change field',
    description: 'The button text for the change field button.',
  },
  'field-settings.change-field-cancel-button': {
    id: 'field-settings.change-field-cancel-button',
    defaultMessage: 'Cancel',
    description: 'The button text for the change field cancel button.',
  },
  'field-settings.delete-field': {
    id: 'field-settings.delete-field',
    defaultMessage: 'Delete field',
    description: 'The heading and label text for the delete field dialog.',
  },
  'field-settings.delete-multiple-fields-confirmation-message.fields': {
    id: 'field-settings.delete-multiple-fields-confirmation-message',
    defaultMessage:
      'Deleting the following {fieldsNumber, plural, =1 {field} other {fields}} will remove this data from all entries in the database: {fields}',
    description:
      'The heading text for the delete multiple fields dialog. {fields} is a list of field names.',
  },
  'field-settings.delete-multiple-fields-confirmation-message.additional': {
    id: 'field-settings.delete-multiple-fields-confirmation-message.additional',
    defaultMessage:
      'Deleted fields will no longer be viewable in other databases or embeds.',
    description: 'The additional text for the delete multiple fields dialog.',
  },
  'field-settings.field-type-dropdown-no-matches-text': {
    id: 'field-settings.field-type-dropdown-no-matches-text',
    defaultMessage: 'No matches found',
    description: 'The text for the field type dropdown when no matches are found.',
  },
  'field-settings-picker.sort-by-field-tooltip': {
    id: 'field-settings-picker.sort-by-field-tooltip',
    defaultMessage: 'Sort by field',
    description: 'The tooltip for the sort picker when no field is selected.',
  },
  'field-settings-picker.sort-picker-button-text': {
    id: 'field-settings-picker.sort-picker-button-text',
    defaultMessage: 'Sort',
    description: 'The button text for the sort picker trigger button.',
  },
  'field-settings-picker.hidden-fields-tooltip': {
    id: 'field-settings-picker.hidden-fields-tooltip',
    defaultMessage: '{fieldsCount} hidden fields',
    description: 'The tooltip for the fields picker when multiple fields are hidden.',
  },
  'field-settings-picker.hidden-field-tooltip': {
    id: 'field-settings-picker.hidden-field-tooltip',
    defaultMessage: '1 hidden field',
    description: 'The tooltip for the fields picker when one field is hidden.',
  },
  'field-settings-picker.hide-fields-tooltip': {
    id: 'field-settings-picker.hide-fields-tooltip',
    defaultMessage: 'Hide fields',
    description: 'The tooltip for the fields picker when no fields are hidden.',
  },
  'field-settings-picker.hide-field-picker-button-text': {
    id: 'field-settings-picker.hide-field-picker-button-text',
    defaultMessage: 'Fields',
    description: 'The button text for the fields picker trigger button.',
  },
  'field-type.category-basic': {
    id: 'field-type.category-basic',
    defaultMessage: 'Basic',
    description:
      'The category label for the add field dropdown menu. Pertaining to field types such as Text, Number, Date, etc.',
  },
  'field-type.category-jira': {
    id: 'field-type.category-jira',
    defaultMessage: 'Jira',
    description:
      'The category label for the add field dropdown menu. Pertaining to field types that has to do with Jira such as jira issue and jira issue details.',
  },
  'field-type.category-other-databases': {
    id: 'field-type.category-other-databases',
    defaultMessage: 'Other Databases',
    description:
      'The category label for the add field dropdown menu. Pertaining to field types that has to do with entries such as entry link, entry detail, etc',
  },
  'field-type.category-page': {
    id: 'field-type.category-page',
    defaultMessage: 'Page',
    description:
      'The category label for the add field dropdown menu. Pertaining to field types that has to do with page such as page links, page status, etc.',
  },
  'field-type.category-page-and-live-doc': {
    id: 'field-type.category-page-and-live-doc',
    defaultMessage: 'Page and live doc',
    description:
      'The category label for the add field dropdown menu. Pertaining to field types that has to do with Page and live doc such as links, status, etc.',
  },
  'field-type.search-text': {
    id: 'field-type.search-text',
    defaultMessage: 'Search',
    description: 'The label and placeholder text for the field type search.',
  },
  'field-value.empty-state.default-text': {
    id: 'field-value.empty-state.default-text',
    defaultMessage: 'Add {defaultText}',
    description:
      'The default text displayed for values when a user has not entered anything.',
  },
  'field-settings.type-text': {
    id: 'field-settings.type-text',
    defaultMessage: 'Text',
    description:
      'The text associated with the dropdown menu button for the Text database field type.',
  },
  'field-settings.type-checkbox': {
    id: 'field-settings.type-checkbox',
    defaultMessage: 'Checkbox',
    description:
      'The text associated with the dropdown menu button for the Checkbox database field type.',
  },
  'field-settings.type-checkbox-short-description': {
    id: 'field-settings.type-checkbox-short-description',
    defaultMessage: 'Add a checkbox',
    description:
      'The tooltip associated with the dropdown menu button for the Checkbox database field type.',
  },
  'field-settings.type-text-short-description': {
    id: 'field-settings.type-text-short-description',
    defaultMessage: 'Add simple text',
    description:
      'The tooltip associated with the dropdown menu button for the Text database field type.',
  },
  'field-settings.type-attachment': {
    id: 'field-settings.type-attachment',
    defaultMessage: 'Media and files',
    description:
      'The text associated with the dropdown menu button for the media and files database field type.',
  },
  'field-settings.type-attachment-size-field': {
    id: 'field-settings.type-attachment-size-field',
    defaultMessage: 'Display size',
    description:
      'The text associated with the display size field for media and files database field type.',
  },
  'field-settings.type-attachment-size-field-autofill': {
    id: 'field-settings.type-attachment-size-field-autofill',
    defaultMessage: 'Autofill',
    description:
      'The text associated with the display size setting autofill for media and files database field type.',
  },
  'field-settings.type-attachment-size-field-thumbnail': {
    id: 'field-settings.type-attachment-size-field-thumbnail',
    defaultMessage: 'Thumbnail',
    description:
      'The text associated with the display size setting thumbnail for media and files database field type.',
  },
  'field-settings.type-number': {
    id: 'field-settings.type-number',
    defaultMessage: 'Number',
    description:
      'The text associated with the dropdown menu button for the Number database field type.',
  },
  'field-settings.type-date': {
    id: 'field-settings.type-date',
    defaultMessage: 'Date',
    description:
      'The text associated with the dropdown menu button for the Date database field type.',
  },
  'field-settings.type-date-format': {
    id: 'field-settings.type-date-format',
    defaultMessage: 'Date format',
    description:
      'The text associated with the dropdown menu button for the Date format field setting.',
  },
  'field-settings.type-date-enable-range': {
    id: 'field-settings.type-date-enable-range',
    defaultMessage: 'Enable date range',
    description:
      'The text associated with the checkbox to enable date range for the Date database field type.',
  },
  'field-settings.type-date-format-default': {
    id: 'field-settings.type-date-format-default',
    defaultMessage: 'Default',
    description: 'The text associated with the default date format.',
  },
  'field-settings.type-date-format-full': {
    id: 'field-settings.type-date-format-full',
    defaultMessage: 'Full date',
    description: 'The text associated with the full date format.',
  },
  'field-settings.type-date-format-mdy': {
    id: 'field-settings.type-date-format-mdy',
    defaultMessage: 'Month / Day / Year',
    description: 'The text associated with the Month / Day / Year date format.',
  },
  'field-settings.type-date-format-dmy': {
    id: 'field-settings.type-date-format-dmy',
    defaultMessage: 'Day / Month / Year',
    description: 'The text associated with the Day / Month / Year date format.',
  },
  'field-settings.type-date-format-ymd': {
    id: 'field-settings.type-date-format-ymd',
    defaultMessage: 'Year / Month / Day',
    description: 'The text associated with the Year / Month / Day date format.',
  },
  'field-settings.type-date-include-time': {
    id: 'field-settings.type-date-include-time',
    defaultMessage: 'Include time',
    description:
      'The text associated with the checkbox to include time in the date field.',
  },
  'field-settings.type-date-time-format-12-hour': {
    id: 'field-settings.type-date-time-format-12-hour',
    defaultMessage: '12-hour',
    description: 'The text associated with the 12-hour time format.',
  },
  'field-settings.type-date-time-format-24-hour': {
    id: 'field-settings.type-date-time-format-24-hour',
    defaultMessage: '24-hour',
    description: 'The text associated with the 24-hour time format.',
  },
  'field-settings.type-tag': {
    id: 'field-settings.type-tag',
    defaultMessage: 'Tag',
    description:
      'The text associated with the dropdown menu button for the Tag database field type.',
  },
  'field-settings.type-tag-short-description': {
    id: 'field-settings.type-tag-short-description',
    defaultMessage: 'Create tags for categorization',
    description:
      'The tooltip associated with the dropdown menu button for the Tag database field type.',
  },
  'field-settings.type-user': {
    id: 'field-settings.type-user',
    defaultMessage: 'User',
    description:
      'The text associated with the dropdown menu button for the User database field type.',
  },
  'field-settings.type-user-short-description': {
    id: 'field-settings.type-user-short-description',
    defaultMessage: 'Tag users in your organization',
    description:
      'The tooltip associated with the dropdown menu button for the User database field type.',
  },
  'field-settings.type-link': {
    id: 'field-settings.type-link',
    defaultMessage: 'Smart Link',
    description:
      'The text associated with the dropdown menu button for the Smart Link database field type.',
  },
  'field-settings.type-link-jira-authenticate-text': {
    id: 'field-settings.type-link-jira-authenticate-text',
    defaultMessage: 'authenticate for details',
    description: 'The button text to authenticate with Jira.',
  },
  'field-settings.type-link-short-description': {
    id: 'field-settings.type-link-short-description',
    defaultMessage: 'Include links or URLs',
    description:
      'The tooltip associated with the dropdown menu button for the Link database field type.',
  },
  'field-settings.type-page-link': {
    id: 'field-settings.type-page-link',
    defaultMessage: 'Page link',
    description:
      'The text associated with the dropdown menu button for the Page link database field type.',
  },
  'field-settings.type-content-link': {
    id: 'field-settings.type-content-link',
    defaultMessage: 'Link',
    description:
      'The text associated with the dropdown menu button for the Link database field type.',
  },
  'field-settings.type-page-link-short-description': {
    id: 'field-settings.type-page-link-short-description',
    defaultMessage: 'Link Confluence pages',
    description:
      'The tooltip associated with the dropdown menu button for the Page link database field type.',
  },
  'field-settings.type-content-link-short-description': {
    id: 'field-settings.type-content-link-short-description',
    defaultMessage: 'Link Confluence pages or live docs',
    description:
      'The tooltip associated with the dropdown menu button for the Content link database field type.',
  },
  'field-settings.type-page-status': {
    id: 'field-settings.type-page-status',
    defaultMessage: 'Page status',
    description:
      'The text associated with the dropdown menu button for the Page status database field type.',
  },
  'field-settings.type-content-status': {
    id: 'field-settings.type-content-status',
    defaultMessage: 'Status',
    description:
      'The text associated with the dropdown menu button for the Content status database field type.',
  },
  'field-settings.type-page-status-short-description': {
    id: 'field-settings.type-page-status-short-description',
    defaultMessage: 'Display Confluence page status',
    description:
      'The tooltip associated with the dropdown menu button for the Page status database field type.',
  },
  'field-settings.type-content-status-short-description': {
    id: 'field-settings.type-content-status-short-description',
    defaultMessage: 'Display Confluence page or doc status',
    description:
      'The tooltip associated with the dropdown menu button for the Content status database field type.',
  },
  'field-settings.type-page-status-description': {
    id: 'field-settings.type-page-status-description',
    defaultMessage: 'Display the statuses of linked Confluence pages',
    description:
      'Text in the field settings describing the Page status database field type.',
  },
  'field-settings.type-page-and-live-doc-status-description': {
    id: 'field-settings.type-page-and-live-doc-status-description',
    defaultMessage: 'Display the statuses of linked Confluence pages and live docs',
    description: 'Text in the field settings describing the Status database field type.',
  },
  'field-settings.type-page-status-error-description': {
    id: 'field-settings.type-page-status-error-description',
    defaultMessage:
      'The page status field requires a page link field in the database first',
    description:
      'Text in the field settings describing the Page status database field type when there is an error.',
  },
  'field-settings.type-status-error-description': {
    id: 'field-settings.type-status-error-description',
    defaultMessage: 'The status field requires a link field in the database first',
    description:
      'Text in the field settings describing the Status database field type when there is an error.',
  },
  'field-settings.type-page-label': {
    id: 'field-settings.type-page-label',
    defaultMessage: 'Page label',
    description:
      'The text associated with the dropdown menu button for the Page label database field type.',
  },
  'field-settings.type-content-label': {
    id: 'field-settings.type-content-label',
    defaultMessage: 'Label',
    description:
      'The text associated with the dropdown menu button for the Content label database field type.',
  },
  'field-settings.type-page-label-short-description': {
    id: 'field-settings.type-page-label-short-description',
    defaultMessage: 'Display Confluence’s page’s attached labels',
    description:
      'The tooltip associated with the dropdown menu button for the Page label database field type.',
  },
  'field-settings.type-content-label-short-description': {
    id: 'field-settings.type-content-label-short-description',
    defaultMessage: 'Display Confluence pages and live docs attached labels',
    description:
      'The tooltip associated with the dropdown menu button for the Content label database field type.',
  },
  'field-settings.type-page-label-error-description': {
    id: 'field-settings.type-page-label-error-description',
    defaultMessage:
      'The page label field requires a page link field in the database first',
    description:
      'Text in the field settings describing the Page label database field type when there is an error.',
  },
  'field-settings.type-label-error-description': {
    id: 'field-settings.type-label-error-description',
    defaultMessage: 'The label field requires a link field in the database first',
    description:
      'Text in the field settings describing the Label database field type when there is an error.',
  },
  'field-settings.type-page-label-description': {
    id: 'field-settings.type-page-label-description',
    defaultMessage: 'Display the labels of linked Confluence pages',
    description:
      'Text in the field settings describing the Page label database field type.',
  },
  'field-settings.type-page-and-live-doc-label-description': {
    id: 'field-settings.type-page-and-live-doc-label-description',
    defaultMessage: 'Display the labels of linked Confluence pages and live docs',
    description: 'Text in the field settings describing the Label database field type.',
  },
  'field-settings.type-page-details': {
    id: 'field-settings.type-page-details',
    defaultMessage: 'Page details',
    description:
      'The text associated with the dropdown menu button for the Page details database field type.',
  },
  'field-settings.type-content-details': {
    id: 'field-settings.type-content-details',
    defaultMessage: 'Details',
    description:
      'The text associated with the dropdown menu button for the Content details database field type.',
  },
  'field-settings.type-page-details-short-description': {
    id: 'field-settings.type-page-details-short-description',
    defaultMessage: 'Display Confluence page creation details',
    description:
      'The tooltip associated with the dropdown menu button for the Page details database field type.',
  },
  'field-settings.type-content-details-short-description': {
    id: 'field-settings.type-content-details-short-description',
    defaultMessage: 'Display Confluence page and doc creation details',
    description:
      'The tooltip associated with the dropdown menu button for the Content details database field type.',
  },
  'field-settings.type-page-details-description': {
    id: 'field-settings.type-page-details-description',
    defaultMessage: 'Display selected details of linked Confluence pages',
    description:
      'Text in the field settings describing the Page details database field type.',
  },
  'field-settings.type-page-and-live-doc-details-description': {
    id: 'field-settings.type-page-and-live-doc-details-description',
    defaultMessage: 'Display selected details of linked Confluence pages and live docs',
    description: 'Text in the field settings describing the Details database field type.',
  },
  'field-settings.type-page-details-error-description': {
    id: 'field-settings.type-page-details-error-description',
    defaultMessage:
      'The page details field requires a page link field in the database first',
    description:
      'Text in the field settings describing the Page details field type when there is an error.',
  },
  'field-settings.type-details-error-description': {
    id: 'field-settings.type-details-error-description',
    defaultMessage: 'The details field requires a link field in the database first',
    description:
      'Text in the field settings describing the Details field type when there is an error.',
  },
  'field-settings.type-entry-link': {
    id: 'field-settings.type-entry-link',
    defaultMessage: 'Entry link',
    description:
      'The text associated with the dropdown menu button for the Entry link database field type.',
  },
  'field-settings.type-entry-link-short-description': {
    id: 'field-settings.type-entry-link-short-description',
    defaultMessage: 'Link to an entry from another database',
    description:
      'The tooltip associated with the dropdown menu button for the Entry link database field type.',
  },
  'field-settings.type-entry-link-description': {
    id: 'field-settings.type-entry-link-description',
    defaultMessage:
      'Use the entry link field to select and display entries from another database.',
    description:
      'Text in the field settings describing the Entry link database field type.',
  },
  'field-settings.type-entry-details': {
    id: 'field-settings.type-entry-details',
    defaultMessage: 'Entry details',
    description:
      'The text associated with the dropdown menu button for the Entry details database field type.',
  },
  'field-settings.type-entry-details-short-description': {
    id: 'field-settings.type-entry-details-short-description',
    defaultMessage: 'Display details from a linked entry from another database',
    description:
      'The tooltip associated with the dropdown menu button for the Entry details database field type.',
  },
  'field-settings.type-entry-details-description': {
    id: 'field-settings.type-entry-details-description',
    defaultMessage:
      'Use the entry details field to display a specific value from a linked database entry. This field requires an existing entry link or backlink field in the same database.',
    description:
      'Text in the field settings describing the Entry details database field type.',
  },
  'field-settings.type-entry-details-error-description': {
    id: 'field-settings.type-entry-details-error-description',
    defaultMessage:
      'The entry link details field requires an entry link or backlink field in the database first',
    description:
      'Text in the field settings describing the Entry details database field type when there is an error.',
  },
  'field-settings.type-entry-backlink': {
    id: 'field-settings.type-entry-backlink',
    defaultMessage: 'Entry backlink',
    description:
      'The text associated with the dropdown menu button for the Entry backlink database field type.',
  },
  'field-settings.type-entry-backlink-short-description': {
    id: 'field-settings.type-entry-backlink-short-description',
    defaultMessage:
      'Display where or how many times an entry is referenced in another database',
    description:
      'The tooltip associated with the dropdown menu button for the Entry backlink database field type.',
  },
  'field-settings.type-entry-backlink-description': {
    id: 'field-settings.type-entry-backlink-description',
    defaultMessage:
      'Use the backlink field to display or count links from another database this entry is linked in.',
    description:
      'Text in the field settings describing the Entry backlink database field type.',
  },
  'field-settings.type-jira-issue': {
    id: 'field-settings.type-jira-issue',
    defaultMessage: 'Jira issue',
    description:
      'The text associated with the dropdown menu button for the Jira issue database field type.',
  },
  'field-settings.type-jira-issue-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-issue-terminology-refresh-m4',
    defaultMessage: 'Jira work item',
    description:
      'The text associated with the dropdown menu button for the Jira issue database field type.',
  },
  'field-settings.type-jira-issue-short-description': {
    id: 'field-settings.type-jira-issue-short-description',
    defaultMessage: 'Link to a Jira issue',
    description:
      'The tooltip associated with the dropdown menu button for the Jira issue database field type.',
  },
  'field-settings.type-jira-issue-short-description-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-short-description-issue-terminology-refresh-m4',
    defaultMessage: 'Link to a Jira work item',
    description:
      'The tooltip associated with the dropdown menu button for the Jira issue database field type.',
  },
  'field-settings.type-jira-issue-details': {
    id: 'field-settings.type-jira-issue-details',
    defaultMessage: 'Jira issue details',
    description:
      'The text associated with the dropdown menu button for the Jira issue details database field type.',
  },
  'field-settings.type-jira-issue-details-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-details-issue-terminology-refresh-m4',
    defaultMessage: 'Jira work item details',
    description:
      'The text associated with the dropdown menu button for the Jira issue details database field type.',
  },
  'field-settings.type-jira-issue-selector-placeholder': {
    id: 'field-settings.type-jira-issue-selector-placeholder',
    defaultMessage: 'Select a Jira issue field...',
    description: 'The placeholder text for the Jira issue field dropdown.',
  },
  'field-settings.type-jira-issue-selector-placeholder-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-selector-placeholder-issue-terminology-refresh-m4',
    defaultMessage: 'Select a Jira work item field...',
    description: 'The placeholder text for the Jira issue field dropdown.',
  },
  'field-settings.type-entry-link-selector-placeholder': {
    id: 'field-settings.type-entry-link-selector-placeholder',
    defaultMessage: 'Select an entry link...',
    description: 'The placeholder text for the entry link field dropdown.',
  },
  'field-settings.type-entry-link-value-selector-placeholder': {
    id: 'field-settings.type-entry-link-value-selector-placeholder',
    defaultMessage: 'Select value...',
    description: 'The placeholder text for the entry link value dropdown.',
  },
  'field-settings.type-jira-issue-details-short-description': {
    id: 'field-settings.type-jira-issue-details-short-description',
    defaultMessage: 'Display a Jira issue with synced details',
    description:
      'The tooltip associated with the dropdown menu button for the Jira issue details database field type.',
  },
  'field-settings.type-jira-issue-details-short-description-issue-terminology-refresh-m4':
    {
      id: 'field-settings.type-jira-issue-details-short-description-issue-terminology-refresh-m4',
      defaultMessage: 'Display a Jira work item with synced details',
      description:
        'The tooltip associated with the dropdown menu button for the Jira issue details database field type.',
    },
  'field-settings.type-jira-issue-details-error-description': {
    id: 'field-settings.type-jira-issue-details-error-description',
    defaultMessage:
      'The Jira issue details field requires a Jira issue field in the database first',
    description:
      'Text in the field settings describing the Jira details field type when there is an error.',
  },
  'field-settings.type-jira-issue-details-error-description-issue-terminology-refresh-m4':
    {
      id: 'field-settings.type-jira-issue-details-error-description-issue-terminology-refresh-m4',
      defaultMessage:
        'The Jira work item details field requires a Jira work item field in the database first',
      description:
        'Text in the field settings describing the Jira details field type when there is an error.',
    },
  'field-settings.type-jira-issue-details-description': {
    id: 'field-settings.type-jira-issue-details-description',
    defaultMessage:
      'Use the Jira issue details field to display the values of individual fields from a linked Jira issue. This field requires an existing Jira issue field in the same database.',
    description:
      'Text in the field settings describing the Jira issue details database field type.',
  },
  'field-settings.type-jira-issue-details-description-issue-terminology-refresh-m4': {
    id: 'field-settings.type-jira-issue-details-description-issue-terminology-refresh-m4',
    defaultMessage:
      'Use the Jira work item details field to display the values of individual fields from a linked Jira work item. This field requires an existing Jira work item field in the same database.',
    description:
      'Text in the field settings describing the Jira issue details database field type.',
  },
  'field-settings.add-field-text': {
    id: 'field-settings.add-field-text',
    defaultMessage: 'Add {fieldName} field',
    description:
      'Text in the field settings describing the Jira issue details database field type.',
  },
  'field-settings.create-field-apply-button-text': {
    id: 'field-settings.create-field-apply-button-text',
    defaultMessage: 'Apply',
    description: 'The button text for the apply button in the create field panel.',
  },
  'field-settings.search-text': {
    id: 'field-settings.search-text',
    defaultMessage: 'Search',
    description:
      'The text associated with the search bar and label for the field settings search.',
  },
  'field-settings.field-name-inline-edit-default-text': {
    id: 'field-settings.field-name-inline-edit-default-text',
    defaultMessage: '{defaultFieldName} field',
    description: 'The default field name for a field name.',
  },
  'field-settings.select-picker-create-text': {
    id: 'field-settings.select-picker-create-text',
    defaultMessage: 'Create',
    description: 'The text for creating a new tag in the tag field setting.',
  },
  'field-settings.select-picker-loading-text': {
    id: 'field-settings.select-picker-loading-text',
    defaultMessage: 'Loading...',
    description:
      'The text that is shown when the data for a select dropdown is still loading.',
  },
  'field-settings.parent-picker-source-database-label': {
    id: 'field-settings.parent-picker-source-database-label',
    defaultMessage: 'Source Database',
    description: 'The label for the source database in the parent picker dropdown.',
  },
  'field-settings.parent-picker-recently-viewed-pages-label': {
    id: 'field-settings.parent-picker-recently-viewed-pages-label',
    defaultMessage: 'Recently viewed content',
    description:
      'The label for the recently viewed content in the parent picker dropdown.',
  },
  'field-settings.field-deleted-externally-message': {
    id: 'field-settings.field-deleted-externally-message',
    defaultMessage: 'The field you were working on has been deleted',
    description:
      'The message displayed to the user when the field they have the field settings dialog open for was deleted by another user',
  },
  'field.default-name.text': {
    id: 'field.default-text.text',
    defaultMessage: 'text',
    description: 'The default name for a text field',
  },
  'field.default-name.media': {
    id: 'field.default-text.media',
    defaultMessage: 'media',
    description: 'The default name for a media field',
  },
  'field.default-name.number': {
    id: 'field.default-text.number',
    defaultMessage: 'number',
    description: 'The default name for a number field',
  },
  'field.default-name.date': {
    id: 'field.default-text.date',
    defaultMessage: 'date',
    description: 'The default name for a date field',
  },
  'field.default-name.tag': {
    id: 'field.default-text.tag',
    defaultMessage: 'tag',
    description: 'The default name for a tag field',
  },
  'field.default-name.user': {
    id: 'field.default-text.user',
    defaultMessage: 'user',
    description: 'The default name for a user field',
  },
  'field.default-name.hyperlink': {
    id: 'field.default-text.hyperlink',
    defaultMessage: 'link',
    description: 'The default name for a hyperlink field',
  },
  'field.default-name.checkbox': {
    id: 'field.default-text.checkbox',
    defaultMessage: 'checkbox',
    description: 'The default name for a checkbox field',
  },
  'field.default-name.page-link': {
    id: 'field.default-text.page-link',
    defaultMessage: 'page link',
    description: 'The default name for a page link field',
  },
  'field.default-name.page-status': {
    id: 'field.default-text.page-status',
    defaultMessage: 'page status',
    description: 'The default name for a page status field',
  },
  'field.default-name.page-labels': {
    id: 'field.default-text.page-labels',
    defaultMessage: 'page label',
    description: 'The default name for a page labels field',
  },
  'field.default-name.page-details': {
    id: 'field.default-text.page-details',
    defaultMessage: 'page details',
    description: 'The default name for a page details field',
  },
  'field.default-name.entry-link': {
    id: 'field.default-text.entry-link',
    defaultMessage: 'entry link',
    description: 'The default name for an entry link field',
  },
  'field.default-name.entry-details': {
    id: 'field.default-text.entry-details',
    defaultMessage: 'entry details',
    description: 'The default name for an entry details field',
  },
  'field.default-name.backlink': {
    id: 'field.default-text.backlink',
    defaultMessage: 'entry backlink',
    description: 'The default name for a backlink field',
  },
  'field.default-name.jira-issue': {
    id: 'field.default-text.jira-issue',
    defaultMessage: 'work item',
    description: 'The default name for a JIRA issue field',
  },
  'field.default-name.jira-issue-details': {
    id: 'field.default-text.jira-issue-details',
    defaultMessage: 'work item details',
    description: 'The default name for a JIRA issue details field',
  },
  'field.default-field-name': {
    id: 'field.default-field-name',
    defaultMessage: 'Field name',
    description: 'The default name for a field',
  },
  'button-message.undo-action': {
    id: 'button-message.undo-action',
    defaultMessage: 'Undo',
    description:
      'This message is the text of the link that will allow them to undo the operation.',
  },
  'button-message.dismiss-action': {
    id: 'button-message.dismiss-action',
    defaultMessage: 'Dismiss',
    description:
      'This message is the text of the link that will allow them to dismiss the message visual.',
  },
  'generic-error.header': {
    id: 'generic-error.header',
    defaultMessage: 'Uh oh. Something went wrong!',
    description: 'The error message shown when an error is thrown and the app crashes.',
  },
  'generic-panel.close-button': {
    id: 'generic-panel.close-button',
    defaultMessage: 'Close',
    description: 'The label text for the close button in the panel.',
  },
  'generic-select.no-options': {
    id: 'generic-select.no-options',
    defaultMessage: 'No options',
    description:
      'The message displayed for a select dropdown when there is no option that the user can select.',
  },
  'jira-user-picker.in-this-database': {
    id: 'jira-user-picker.in-this-database',
    defaultMessage: 'In this database',
    description:
      'The group label for users that appear in existing database entries when filtering by Jira user fields.',
  },
  'jira-user-picker.all-users': {
    id: 'jira-user-picker.all-users',
    defaultMessage: 'All users',
    description:
      'The group label for users from the global user search when filtering by Jira user fields.',
  },
  'include-version-comment.checkbox-text': {
    id: 'include-version-comment.checkbox-text',
    defaultMessage: 'Include version comment',
    description:
      'The text associated with the checkbox to include the version comment in the field settings.',
  },
  'layout.board-edit-option-label': {
    id: 'layout.board-edit-option-label',
    defaultMessage: 'Edit option',
    description:
      'The text associated with the button to add a select field in the board layout.',
  },
  'layout.layout-tooltip-text': {
    id: 'layout.layout-tooltip-text',
    defaultMessage: '{layoutType} layout',
    description: 'The text for the table, card or board layout tooltip.',
  },
  'number-field.decimal-places': {
    id: 'number-field.decimal-places',
    defaultMessage: 'Decimal places',
    description: 'The label text for the decimal places input field.',
  },
  'number-field.thousands-and-decimal-separators': {
    id: 'number-field.thousands-and-decimal-separators',
    defaultMessage: 'Thousands and decimal separators',
    description: 'The label text for the thousands and decimal separators input field.',
  },
  'number-field.decimal-places-manual': {
    id: 'number-field.decimal-places-manual',
    defaultMessage: 'Manual',
    description:
      'The label text for the default decimal places option. Manual means the user will type in their own decimal places.',
  },
  'number-field.decimal-places-none': {
    id: 'number-field.decimal-places-none',
    defaultMessage: 'None',
    description:
      'The default message for when a user has not selected any decimal place option.',
  },
  'onboarding-tour.advance-spotlight': {
    id: 'onboarding-tour.advance-spotlight',
    defaultMessage: 'Next',
    description: 'A next button to advance to the next spotlight in the onboarding tour.',
  },
  'onboarding-tour.complete-spotlight': {
    id: 'onboarding-tour.complete-spotlight',
    defaultMessage: 'Done',
    description: 'A done button to complete all four steps of the onboarding tour.',
  },
  'onboarding-tour.dismiss-spotlight': {
    id: 'onboarding-tour.dismiss-spotlight',
    defaultMessage: 'Dismiss',
    description: 'A dismiss button to exist out of the onboarding tour.',
  },
  'onboarding-tour.spotlight-one-of-three': {
    id: 'onboarding-tour.spotlight-one-of-three',
    defaultMessage: 'Add new field types to structure values in your database.',
    description:
      'The first of the three onboarding tour spotlight messages that highlights the ability to create a new field for users new to the app.',
  },
  'onboarding-tour.spotlight-two-of-three': {
    id: 'onboarding-tour.spotlight-two-of-three',
    defaultMessage: 'Edit field types to configure your data.',
    description:
      'The second of the three onboarding tour spotlight messages that highlights the ability to edit field settings for users new to the app.',
  },
  'onboarding-tour.spotlight-three-of-three': {
    id: 'onboarding-tour.spotlight-three-of-three',
    defaultMessage:
      'Save new views and set defaults to look at your data however you want.',
    description:
      'The last of the three onboarding tour spotlight messages that highlights the ability to interact with views for users new to the app.',
  },
  'page-details-value.version-abbreviated': {
    id: 'page-details-value.version-abbreviated',
    defaultMessage: 'v.',
    description: 'The abbreviation of the word "version" for example "v.12"',
  },
  'page-status.no-options': {
    id: 'page-status.no-options',
    defaultMessage:
      'No options. This could be because content statuses are disabled for this space or because you don’t have permission to edit the linked content.',
    description:
      'The helper text that displays under the dropdown when clicking on a Page Status field that is configured to point to a Page Link field in the settings but still contains no results. It clarifies the no results outcome by suggesting to the user that they might not have permission to edit the linked content.',
  },
  'quick.calculations.field-disabled-text': {
    id: 'quick.calculations.field-disabled-text',
    defaultMessage: 'Calculations are not currently available for this field type',
    description:
      'This text is show in the toolbar when the user hovers a disabled button for quick calc. This informs them the field type they are using is not yet supported with quick calc.',
  },
  'quick.calculations.placeholder-text': {
    id: 'quick.calculations.placeholder-text',
    defaultMessage: 'Calculate',
    description: 'The placeholder text for the quick calculations dropdown menu.',
  },
  'quick.calculations.calculation-type-none': {
    id: 'quick.calculations.calculation-type-none',
    defaultMessage: 'None',
    description:
      'The user has the option to remove the calculation on the field. They do this by selecting "None" from the dropdown.',
  },
  'quick.calculations.check-icon': {
    id: 'quick.calculations.check-icon',
    defaultMessage: 'Check',
    description:
      'A check icon is displayed for the selected calculation type. This is the label for that icon.',
  },
  'quick-calculations.calculation-type-sum': {
    id: 'quick-calculations.calculation-type-sum',
    defaultMessage: 'Sum',
    description:
      'The label for the "Sum" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-count-total': {
    id: 'quick-calculations.calculation-type-count-total',
    defaultMessage: 'Count entries',
    description:
      'The label for the "Count entries" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-count': {
    id: 'quick-calculations.calculation-type-count',
    defaultMessage: 'Count values',
    description:
      'The label for the "Count values" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-count-empty': {
    id: 'quick-calculations.calculation-type-count-empty',
    defaultMessage: 'Count empty',
    description:
      'The label for the "Count empty" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-count-unique': {
    id: 'quick-calculations.calculation-type-count-unique',
    defaultMessage: 'Count unique values',
    description:
      'The label for the "Count unique" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-average': {
    id: 'quick-calculations.calculation-type-average',
    defaultMessage: 'Average',
    description:
      'The label for the "Average" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-min': {
    id: 'quick-calculations.calculation-type-min',
    defaultMessage: 'Min',
    description:
      'The label for the "Min" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-max': {
    id: 'quick-calculations.calculation-type-max',
    defaultMessage: 'Max',
    description:
      'The label for the "Max" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-percent-empty': {
    id: 'quick-calculations.calculation-type-percent-empty',
    defaultMessage: 'Percent empty',
    description:
      'The label for the "Percent empty" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-percent-not-empty': {
    id: 'quick-calculations.calculation-type-percent-not-empty',
    defaultMessage: 'Percent not empty',
    description:
      'The label for the "Percent not empty" calculation type in the quick calculations dropdown.',
  },
  'quick-calculations.calculation-type-percent-checked': {
    id: 'quick-calculations.calculation-type-percent-checked',
    defaultMessage: 'Percent checked',
    description:
      'The label for the "Percent checked" calculation type in the quick calculations dropdown, used for checkbox fields.',
  },
  'quick-calculations.calculation-type-percent-unchecked': {
    id: 'quick-calculations.calculation-type-percent-unchecked',
    defaultMessage: 'Percent unchecked',
    description:
      'The label for the "Percent unchecked" calculation type in the quick calculations dropdown, used for checkbox fields.',
  },
  'quick-search.quick-search-tooltip-text': {
    id: 'quick-search.quick-search-tooltip-text',
    defaultMessage: 'Quick search:',
    description: 'The tooltip text for the quick search tooltip.',
  },
  'quick-search.mac-modifier': {
    id: 'quick-search.mac-modifier',
    defaultMessage: '⌘',
    description:
      'Mac modifier key. Note for translators: Leave this untranslated as the original symbol.',
  },
  'quick-search.ctrl': {
    id: 'quick-search.ctrl',
    defaultMessage: 'Ctrl',
    description:
      'Modifier key for non mac (eg Windows, linux etc), which is the Ctrl/Control key. Please translate to the appropriate abbreviation for the Ctrl key if it exists in the locale, else leave it as Ctrl',
  },
  'quick-search.plus-key': {
    id: 'quick-search.plus-key',
    defaultMessage: '+',
    description: 'Plus key. Leave this untranslated as the original symbol',
  },
  'quick-search.F-key': {
    id: 'quick-search.F-key',
    defaultMessage: 'F',
    description: 'The F key associated with "Ctrl + F" to trigger quick search.',
  },
  'quick-search.search-database-text': {
    id: 'quick-search.search-database-text',
    defaultMessage: 'Search database',
    description: 'The quick search placeholder text.',
  },
  'right-rail-footer.save-button-text': {
    id: 'right-rail-footer.save-button-text',
    defaultMessage: 'Save',
    description: 'The save button for the right rail/dialogs.',
  },
  'right-rail-footer.close-button-text': {
    id: 'right-rail-footer.close-button-text',
    defaultMessage: 'Close',
    description: 'The close button for the right rail/dialogs.',
  },
  'right-rail-footer.cancel-button-text': {
    id: 'right-rail-footer.cancel-button-text',
    defaultMessage: 'Cancel',
    description: 'The cancel button for the right rail/dialogs.',
  },
  'select-dropdown.placeholder': {
    id: 'select-dropdown.placeholder',
    defaultMessage: 'Select...',
    description: 'The default placeholder for a dropdown.',
  },
  'selection-toolbar.delete-column-tooltip': {
    id: 'selection-toolbar.delete-column-tooltip',
    defaultMessage: 'Delete field',
    description: 'The tooltip text indicating to delete one selected column.',
  },
  'table-header.select-all-entries': {
    id: 'table-header.select-all-entries',
    defaultMessage: 'Select all entries',
    description:
      'The accessible label for the header checkbox column that allows selecting all table entries.',
  },
  'bulk-edit-values.tooltip': {
    id: 'bulk-edit-values.tooltip',
    defaultMessage: 'Edit values',
    description:
      'The tooltip text indicating to edit multiple selected values in a bulk operation in the selection toolbar.',
  },
  'bulk-edit-values.label': {
    id: 'bulk-edit-values.label',
    defaultMessage: 'Edit values',
    description: 'The label for the edit values icon',
  },
  'select-or-create-text.placeholder': {
    id: 'select-or-create-text.placeholder',
    defaultMessage: 'Select or create…',
    description: 'The placeholder text for a select or create dropdown.',
  },
  'table-layout.add-entry': {
    id: 'table-layout.add-entry',
    defaultMessage: 'Add entry',
    description: 'The label for the add entry button in the table layout.',
  },
  'table-layout.filtering-entries': {
    id: 'table-layout.filtering-entries',
    defaultMessage: 'Filtering...',
    description:
      'The loading message displayed when filtering on Jira fields while waiting for Jira data to load.',
  },
  'table-layout.sorting-entries': {
    id: 'table-layout.sorting-entries',
    defaultMessage: 'Sorting...',
    description:
      'The loading message displayed when sorting on Jira fields while waiting for Jira data to load.',
  },
  'table-layout.add-field-label': {
    id: 'table-layout.add-field-label',
    defaultMessage: 'Add field',
    description: 'The label for the add field button icon in the table layout.',
  },
  'table-layout.select-row-label': {
    id: 'table-layout.select-row-label',
    defaultMessage: 'Select row',
    description: 'The aria label for the row select button in the table layout.',
  },
  'table-layout.select-column-label': {
    id: 'table-layout.select-column-label',
    defaultMessage: 'Select column',
    description: 'The aria label for the column select button in the table layout.',
  },
  'table-layout.field-settings.label': {
    id: 'table-layout.field-settings.label',
    defaultMessage: 'Edit field',
    description:
      'The aria label for the settings icon that opens the field settings panel in the field header in table layout.',
  },
  'table-layout.attachment-field-value-tooltip': {
    id: 'table-layout.attachment-field-value-tooltip',
    defaultMessage:
      '{isMulti, plural, one {Drag, paste, or click to upload a file.} other {Drag, paste, or click to upload files.}}',
    description:
      'The toolip that displays when a user hovers over the button to upload a file(s) to a cell. It gives the user hints on how to insert a file.',
  },
  'snackbar-error.collab-deleted-view': {
    id: 'snackbar-error.collab-deleted-view',
    defaultMessage: 'The view <strong>{viewName}</strong> was deleted',
    description:
      'The snackbar error message to let the user know that the currently opened view was deleted by a collaborator.',
  },
  'snackbar-error.deleted-linked-view': {
    id: 'snackbar-error.deleted-linked-view',
    defaultMessage: 'The linked view was deleted',
    description:
      'The snackbar error message to let the user know that they are looking at a saved view that has been deleted.',
  },
  'snackbar-error.deleted-linked-entry': {
    id: 'snackbar-error.deleted-linked-entry',
    defaultMessage: 'The linked entry was deleted',
    description:
      'The snackbar error message to let the user know that the entry linked has been deleted.',
  },
  'snackbar-error.entry-link-not-found': {
    id: 'snackbar-error.entry-link-not-found',
    defaultMessage: 'Entry linked in <strong>{fieldName}</strong> can’t be found',
    description:
      'The snackbar error message to let the user know that the entry link field has been deleted.',
  },
  'snackbar-error.entry-link-restricted-permission': {
    id: 'snackbar-error.entry-link-restricted-permission',
    defaultMessage:
      'Entry linked in <strong>{fieldName}</strong> has restrictions applied. Contact owner to request access.',
    description:
      'The snackbar error message to let the user know that the entry link has restricted permissions.',
  },
  'snackbar-error.entry-link-load-error': {
    id: 'snackbar-error.entry-link-load-error',
    defaultMessage:
      'We couldn’t load the entry linked in <strong>{fieldName}</strong>. Try refreshing the database.',
    description:
      'The snackbar error message to let the user know that there was an error loading the entry link.',
  },
  'snackbar-error.jira.auth-required': {
    id: 'snackbar-error.jira.auth-required',
    defaultMessage: 'Authenticate with Jira to access your issues.',
    description:
      'The snackbar error message to let the user know that they need to authenticate with Jira.',
  },
  'snackbar-error.jira.auth-required-issue-terminology-refresh-m4': {
    id: 'snackbar-error.jira.auth-required-issue-terminology-refresh-m4',
    defaultMessage: 'Authenticate with Jira to access your work items.',
    description:
      'The snackbar error message to let the user know that they need to authenticate with Jira.',
  },
  'snackbar-error.jira.authenticate': {
    id: 'snackbar-error.jira.authenticate',
    defaultMessage: 'Authenticate',
    description: 'The link to authenticate with Jira that will open in a popup.',
  },
  'snackbar-error.enable-popup': {
    id: 'snackbar-error.enable-popup',
    defaultMessage:
      'Could not open authentication popup. Please check if your browser blocked the popup.',
    description:
      'The error message shown when popup could not be opened when a user tries to authenticate Jira through the link in the error snackbar message.',
  },
  'snackbar.version-unsupported': {
    id: 'snackbar.version-unsupported',
    defaultMessage: 'A newer version of Confluence databases is available.',
    description:
      'Snackbar message shown when the databases version is no longer supported',
  },
  'snackbar.link.refresh': {
    id: 'snackbar.link.refresh',
    defaultMessage: 'Refresh',
    description: 'The link to refresh the page in the snackbar message.',
  },
  'table-layout.image-field-delete-tooltip': {
    id: 'table-layout.image-field-delete-tooltip',
    defaultMessage: 'Delete image',
    description:
      'The toolip that displays over the trashcan icon for a cell with the Image field type that lets the user know clicking it will remove the image from that cell.',
  },
  'table-layout.no-matching-entries-empty-state-heading': {
    id: 'table-layout.no-matching-entries-empty-state-heading',
    defaultMessage: 'No matching entries found',
    description:
      'The heading text for the empty state when there are no entries found matching a filter in table layout.',
  },
  'table-layout.no-matching-entries-empty-state-description': {
    id: 'table-layout.no-matching-entries-empty-state-description',
    defaultMessage: 'We could not find any entries matching your filters.',
    description:
      'The description text for the empty state when there are no entries found matching a filter in table layout.',
  },
  'table-layout.empty-database-empty-state-heading': {
    id: 'table-layout.empty-database-empty-state-heading',
    defaultMessage: 'Add things to your database',
    description:
      'The heading text for the empty state in table layout when a database is empty.',
  },
  'table-layout.empty-database-empty-state-description': {
    id: 'table-layout.empty-database-empty-state-description',
    defaultMessage: 'Try adding fields or entries to fill in your database.',
    description:
      'The description text for the empty state in table layout when a database is empty.',
  },
  'table-layout.reset-sorting-to-enable-row-dragging': {
    id: 'table-layout.reset-sorting-to-enable-row-dragging',
    defaultMessage: 'Reset sorting to move entries',
    description:
      'The text for the popup message that appears when a user tries to move rows in a table layout but has sorting applied.',
  },
  'table-layout.insert-row-tooltip': {
    id: 'table-layout.insert-row-tooltip',
    defaultMessage: 'Insert entry',
    description: 'The tooltip for the insert row dot in the table layout.',
  },
  'table-layout.insert-column-tooltip': {
    id: 'table-layout.insert-column-tooltip',
    defaultMessage: 'Insert field',
    description: 'The tooltip for the insert column dot in the table layout.',
  },
  'table-layout.drag-to-fill-tooltip': {
    id: 'table-layout.drag-to-fill-tooltip',
    defaultMessage: 'Drag to fill values based on selection',
    description: 'The tooltip for the drag caret in the table layout.',
  },
  'layout.board-add-entry': {
    id: 'layout.board-add-entry',
    defaultMessage: 'Add entry',
    description: 'The button text for the board layout add entry button.',
  },
  'layout.board-add-option': {
    id: 'layout.board-add-option',
    defaultMessage: 'Add option',
    description: 'The button text for the board layout add option button.',
  },
  'layout.card-remaining-values-count': {
    id: 'layout.card-remaining-values-count',
    defaultMessage:
      '+ {valuesCount, plural, one {{valuesCount} value} other {{valuesCount} values}}',
    description:
      'The text for the number of non-empty values that are not displayed on the card.',
  },
  'layout.card-jira-work-items-count': {
    id: 'layout.card-jira-work-items-count',
    defaultMessage:
      'View Jira work {jiraWorkItemCount, plural, one {item} other {items}}',
    description: 'The text for the number of non-empty jira work items for an entry.',
  },
  'layout.card-comment-count': {
    id: 'layout.card-comment-count',
    defaultMessage: 'View {commentCount, plural, one {comment} other {comments}}',
    description: 'The text for the number of non-empty jira work items for an entry.',
  },
  'toolbar-filter.filtered-by-tooltip': {
    id: 'toolbar-filter.filtered-by-tooltip',
    defaultMessage: 'Filtered by',
    description:
      'The tooltip for the filter button in the toolbar when a filter is active.',
  },
  'toolbar-filter.filter-entries-tooltip': {
    id: 'toolbar-filter.filter-entries-tooltip',
    defaultMessage: 'Filtered entries',
    description:
      'The tooltip for the filter button in the toolbar when a filter is inactive.',
  },
  'toolbar-filter.add-filter-description': {
    id: 'toolbar-filter.add-filter-description',
    defaultMessage:
      'Add filter conditions to show only entries that match particular criteria.',
    description: 'The description for the filter form when no filter has been applied.',
  },
  'toolbar-filter.add-filter-button': {
    id: 'toolbar-filter.add-filter-button',
    defaultMessage: 'Add',
    description: 'The button text for the Add filter button.',
  },
  'toolbar-filter.apply-filter-description': {
    id: 'toolbar-filter.apply-filter-description',
    defaultMessage: 'In this view, show entries that match:',
    description:
      'The description for how to apply the "All" and "Any" filter to display the desired entries',
  },
  'toolbar-filter.or-filter-label': {
    id: 'toolbar-filter.or-filter-label',
    defaultMessage: 'any filter',
    description: 'The label for displaying the OR filter',
  },
  'toolbar-filter.remove-filter': {
    id: 'toolbar-filter.remove-filter',
    defaultMessage: 'Remove filter',
    description: 'The tooltip on the trashcan icon for removing a filter',
  },
  'toolbar-filter.type-picker-date-is-on-text': {
    id: 'toolbar-filter.type-picker-date-is-on-text',
    defaultMessage: 'is on',
    description:
      'The text for the "is on" filter date option, i.e. filter by date is on 1/1/2024.',
  },
  'toolbar-filter.type-picker-date-is-not-on-text': {
    id: 'toolbar-filter.type-picker-date-is-not-on-text',
    defaultMessage: 'is not on',
    description:
      'The text for the "is not on" filter date option, i.e. filter by date is not on 1/1/2024.',
  },
  'toolbar-filter.type-picker-is-text': {
    id: 'toolbar-filter.type-picker-is-text',
    defaultMessage: 'is',
    description:
      'The text for the the "is" filter option, i.e. filter by text is foobar.',
  },
  'toolbar-filter.type-picker-is-not-text': {
    id: 'toolbar-filter.type-picker-is-not-text',
    defaultMessage: 'is not',
    description:
      'The text for the "is not" filter option, i.e. filter by text is not foobar.',
  },
  'toolbar-filter.type-picker-number-equals-text': {
    id: 'toolbar-filter.type-picker-number-equals-text',
    defaultMessage: 'equals',
    description:
      'The text for the "equals" filter option for numbers, i.e. filter by: Age equals 45',
  },
  'toolbar-filter.type-picker-number-does-not-equal': {
    id: 'toolbar-filter.type-picker-number-does-not-equal',
    defaultMessage: 'does not equal',
    description:
      'The text for the "does not equal" filter option for numbers, i.e. filter by: Age does not equal 45',
  },
  'toolbar-filter.type-picker-contains-text': {
    id: 'toolbar-filter.type-picker-contains-text',
    defaultMessage: 'contains',
    description: 'The text for the "contains" filter option.',
  },
  'toolbar-filter.type-picker-does-not-contain-text': {
    id: 'toolbar-filter.type-picker-does-not-contain-text',
    defaultMessage: 'does not contain',
    description: 'The text for the "does not contain" filter option.',
  },
  'toolbar-filter.type-picker-is-empty-text': {
    id: 'toolbar-filter.type-picker-is-empty-text',
    defaultMessage: 'is empty',
    description: 'The text for the "is empty" filter option.',
  },
  'toolbar-filter.type-picker-is-not-empty-text': {
    id: 'toolbar-filter.type-picker-is-not-empty-text',
    defaultMessage: 'is not empty',
    description: 'The text for the "is not empty" filter option.',
  },
  'toolbar-filter.type-picker-is-greater-than-text': {
    id: 'toolbar-filter.type-picker-is-greater-than-text',
    defaultMessage: 'is greater than',
    description: 'The text for the "is greater than" filter option.',
  },
  'toolbar-filter.type-picker-is-after-text': {
    id: 'toolbar-filter.type-picker-is-after-text',
    defaultMessage: 'is after',
    description: 'The text for the "is after" date filter option.',
  },
  'toolbar-filter.type-picker-is-on-or-after-text': {
    id: 'toolbar-filter.type-picker-is-on-or-after-text',
    defaultMessage: 'is on or after',
    description: 'The text for the "is on or after" date filter option.',
  },
  'toolbar-filter.type-picker-is-greater-than-or-equal-text': {
    id: 'toolbar-filter.type-picker-is-greater-than-or-equal-text',
    defaultMessage: 'is greater than or equal to',
    description: 'The text for the "is greater than or equal to" date filter option.',
  },
  'toolbar-filter.type-picker-is-before-text': {
    id: 'toolbar-filter.type-picker-is-before-text',
    defaultMessage: 'is before',
    description: 'The text for the "is before" date filter option.',
  },
  'toolbar-filter.type-picker-is-less-than-text': {
    id: 'toolbar-filter.type-picker-is-less-than-text',
    defaultMessage: 'is less than',
    description: 'The text for the "is less than" date filter option.',
  },
  'toolbar-filter.type-picker-is-on-or-before-text': {
    id: 'toolbar-filter.type-picker-is-on-or-before-text',
    defaultMessage: 'is on or before',
    description: 'The text for the "is on or before" date filter option.',
  },
  'toolbar-filter.type-picker-is-less-than-or-equal-text': {
    id: 'toolbar-filter.type-picker-is-less-than-or-equal-text',
    defaultMessage: 'is less than or equal to',
    description: 'The text for the "is less than or equal to" date filter option.',
  },
  'toolbar-filter.filter-button-text': {
    id: 'toolbar-filter.filter-button-text',
    defaultMessage: 'Filter',
    description: 'The text for the filter button.',
  },
  'toolbar-filter.filter-all-text': {
    id: 'toolbar-filter.filter-all-text',
    defaultMessage: 'all',
    description: 'The text for the "all" option in the filter form dropdown.',
  },
  'toolbar-views.embed-visible-tooltip': {
    id: 'toolbar-views.embed-visible-tooltip',
    defaultMessage: 'This view is only visible in this embed',
    description:
      'The tooltip describing that the view is only visible in the current embed.',
  },
  'toolbar-views.default-view-tooltip': {
    id: 'toolbar-views.default-view-tooltip',
    defaultMessage:
      '{isEmbed, select, true {Default view for this embed} other {Default view for this database}}',
    description: 'The tooltip for the default view of a database or embed.',
  },
  'toolbar-views.duplicate-view-warning-text': {
    id: 'toolbar-views.duplicate-view-warning-text',
    defaultMessage: 'A view with this name already exists in this database',
    description:
      'The text for a warning message telling the user that a view with the current name already exists.',
  },
  'toolbar-views.save-button-text': {
    id: 'toolbar-views.save-button-text',
    defaultMessage: 'Save',
    description:
      'The text for a warning message telling the user that a view with the current name already exists.',
  },
  'toolbar-views.default-text': {
    id: 'toolbar-views.default-text',
    defaultMessage: 'default',
    description:
      'The text associated with the default view option in the views dropdown menu.',
  },
  'toolbar-views.view-name-placeholder': {
    id: 'toolbar-views.view-name-placeholder',
    defaultMessage: 'View name',
    description: 'The placeholder text when editing a new view name.',
  },
  'toolbar-views.update-view-flag-body': {
    id: 'toolbar-views.update-view-flag-body',
    defaultMessage: '<strong>{viewName}</strong> view was updated for everyone.',
    description: 'The body text for the view updated flag.',
  },
  'toolbar-views.update-view-for-everyone': {
    id: 'toolbar-views.update-view-for-everyone',
    defaultMessage: 'Update view for everyone',
    description:
      'The text associated with the "Update view for everyone" button update view dropdown.',
  },
  'toolbar-views.delete-view-heading': {
    id: 'toolbar-views.delete-view-heading',
    defaultMessage: 'Delete view?',
    description: 'The heading associated with the delete view confirm dialog.',
  },
  'toolbar-views.delete-view-text': {
    id: 'toolbar-views.delete-view-text',
    defaultMessage:
      'Deleting this view will remove it from all references of this database.',
    description: 'The text associated with the delete view confirm dialog.',
  },
  'toolbar-views.delete-view-cancel-button': {
    id: 'toolbar-views.delete-view-cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The button text for the cancel button in the delete view confirm dialog.',
  },
  'toolbar-views.delete-view-failure-flag-title': {
    id: 'toolbar-views.delete-view-failure-flag-title',
    defaultMessage: 'We couldn’t delete the view',
    description: 'The title text for the delete view failure flag.',
  },
  'toolbar-views.delete-view-failure-flag-description': {
    id: 'toolbar-views.delete-view-failure-flag-description',
    defaultMessage:
      'Databases must have one view. All other views in this database were deleted.',
    description: 'The description text for the delete view failure flag.',
  },
  'export.incomplete-flag-title': {
    id: 'export.incomplete-flag-title',
    defaultMessage: 'Export complete, with warnings',
    description:
      'The title of the flag shown when a database export completes but some data could not be loaded.',
  },
  'export.incomplete-flag-description': {
    id: 'export.incomplete-flag-description',
    defaultMessage:
      'Some database values could not be loaded and may be omitted from your export.',
    description:
      'The description text for the flag shown when a database export succeeds but some data could not be loaded.',
  },
  'export.failure-flag-title': {
    id: 'export.failure-flag-title',
    defaultMessage: 'Export failed',
    description: 'The title text for the flag shown when a database export fails.',
  },
  'export.failure-flag-description': {
    id: 'export.failure-flag-description',
    defaultMessage: 'There was a problem exporting your database. Please try again.',
    description: 'The description text for the flag shown when a database export fails.',
  },
  'unnamed-entities.untitled-database': {
    id: 'unnamed-entities.untitled-database',
    defaultMessage: 'Untitled database',
    description:
      'The placeholder text for the database title field, especially in an embedded database, when there is no value.',
  },
  'unnamed-entities.unnamed-entry': {
    id: 'unnamed-entities.unnamed-entry',
    defaultMessage: 'Unnamed entry',
    description: 'The text for an entry that has not been named.',
  },
  'validation.database-name-length': {
    id: 'validation.database-name-length',
    defaultMessage:
      '{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}',
    description: 'The validation message displayed when the database name is too long.',
  },
  'validation.required-field-setting-tooltip': {
    id: 'validation.required-field-setting-tooltip',
    defaultMessage: 'Required field setting is missing',
    description:
      'The tooltip that displays when hovering on a value for a field that has not yet have all the required settings configured.',
  },
  'validation.required-field': {
    id: 'validation.required-field',
    defaultMessage: 'Please select a field',
    description: 'The field validation warning for missing a required field value.',
  },
  'validation.required-jira-instance': {
    id: 'validation.required-jira-instance',
    defaultMessage: 'Please select a Jira instance.',
    description:
      'The field validation in the Jira Issue field settings Jira Instance dropdown that informs the user a required field setting is missing.',
  },
  'validation.unique-field-name': {
    id: 'validation.unique-field-name',
    defaultMessage: 'Multiple fields cannot have the same name.',
    description:
      'The validation message displayed when trying to save a field name that already exists.',
  },
  'value-inline-edit.required-field-missing-tooltip': {
    id: 'value-inline-edit.required-field-missing-tooltip',
    defaultMessage: 'Required field setting is missing',
    description:
      'The tooltip text indicating that the required field is missing for value inline edit.',
  },
  'view.unsaved-view': {
    id: 'view.unsaved-view',
    defaultMessage: 'Unsaved view',
    description: 'The text label for an unsaved view',
  },
  'entry-actions.expand': {
    id: 'entry-actions.expand',
    defaultMessage: 'Expand entry',
    description: 'The text for the expand entry button in the contextual dropdown menu.',
  },
  'entry-actions.collapse': {
    id: 'entry-actions.collapse',
    defaultMessage: 'Collapse entry',
    description:
      'The text for the collapse entry button in the contextual dropdown menu.',
  },
  'entry-actions.copy-link': {
    id: 'entry-actions.copy-link',
    defaultMessage: 'Copy link to entry',
    description:
      'The text for the copy link to entry button in the contextual dropdown menu.',
  },
  'entry-actions.add-above': {
    id: 'entry-actions.add-above',
    defaultMessage: 'Add entry above',
    description:
      'The text for the add entry above button in the contextual dropdown menu.',
  },
  'entry-actions.add-below': {
    id: 'entry-actions.add-below',
    defaultMessage: 'Add entry below',
    description:
      'The text for the add entry below button in the contextual dropdown menu.',
  },
  'entry-actions.duplicate-entry': {
    id: 'entry-actions.duplicate-entry',
    defaultMessage:
      '{entryCount, plural, one {Duplicate {entryCount} entry} other {Duplicate {entryCount} entries}}',
    description:
      'The text for the duplicate entries button in the contextual dropdown menu.',
  },
  'entry-actions.delete': {
    id: 'entry-actions.delete',
    defaultMessage:
      '{entryCount, plural, one {Delete {entryCount} entry} other {Delete {entryCount} entries}}',
    description:
      'The text for the delete entries button in the contextual dropdown menu.',
  },
  'entry-actions.move-up': {
    id: 'entry-actions.move-up',
    defaultMessage: '{entryCount, plural, one {Move entry up} other {Move entries up}}',
    description: 'The text for the move entry up button in the contextual dropdown menu.',
  },
  'entry-actions.move-down': {
    id: 'entry-actions.move-down',
    defaultMessage:
      '{entryCount, plural, one {Move entry down} other {Move entries down}}',
    description:
      'The text for the move entry down button in the contextual dropdown menu.',
  },
  'entry.entry-deleted-externally-message': {
    id: 'entry.entry-deleted-externally-message',
    defaultMessage: 'The entry you were working on has been deleted',
    description:
      'The message displayed to the user when the entry they have the entry dialog open for was deleted by another user',
  },
  'field-actions.add-left': {
    id: 'field-actions.add-left',
    defaultMessage: 'Add field left',
    description:
      'The text for the add field left button in the contextual dropdown menu.',
  },
  'field-actions.add-right': {
    id: 'field-actions.add-right',
    defaultMessage: 'Add field right',
    description:
      'The text for the add field right button in the contextual dropdown menu.',
  },
  'field-actions.duplicate': {
    id: 'field-actions.duplicate',
    defaultMessage:
      '{fieldCount, plural, one {Duplicate {fieldCount} field} other {Duplicate {fieldCount} fields}}',
    description:
      'The text for the duplicate fields button in the contextual dropdown menu.',
  },
  'field-actions.delete-single': {
    id: 'field-actions.delete-single',
    defaultMessage: 'Delete field',
    description: 'The text for the delete field button in the contextual dropdown menu.',
  },
  'field-actions.delete': {
    id: 'field-actions.delete',
    defaultMessage:
      '{fieldCount, plural, one {Delete {fieldCount} field} other {Delete {fieldCount} fields}}',
    description: 'The text for the delete fields button in the contextual dropdown menu.',
  },
  'field-actions.move-left': {
    id: 'field-actions.move-left',
    defaultMessage:
      '{fieldCount, plural, one {Move field left} other {Move fields left}}',
    description:
      'The text for the move field left button in the contextual dropdown menu.',
  },
  'field-actions.move-right': {
    id: 'field-actions.move-right',
    defaultMessage:
      '{fieldCount, plural, one {Move field right} other {Move fields right}}',
    description:
      'The text for the move field right button in the contextual dropdown menu.',
  },
  'field-actions.filter': {
    id: 'field-actions.filter',
    defaultMessage: 'Filter field',
    description: 'The text for the filter field button in the contextual dropdown menu.',
  },
  'field-actions.sort-increasing': {
    id: 'field-actions.sort-increasing',
    defaultMessage: 'Sort increasing',
    description:
      'The text for the sort increasing button in the contextual dropdown menu.',
  },
  'field-actions.sort-decreasing': {
    id: 'field-actions.sort-decreasing',
    defaultMessage: 'Sort decreasing',
    description:
      'The text for the sort decreasing button in the contextual dropdown menu.',
  },
  'field-actions.hide-fields': {
    id: 'field-actions.hide-fields',
    defaultMessage:
      '{fieldCount, plural, one {Hide field} other {Hide {fieldCount} fields}}',
    description: 'The text for the hide fields button in the contextual dropdown menu.',
  },
  'value-actions.ask-rovo': {
    id: 'value-actions.ask-rovo',
    defaultMessage: 'Ask Rovo',
    description: 'The text for the Ask Rovo button in the contextual dropdown menu.',
  },
  'value-actions.comments': {
    id: 'value-actions.comments',
    defaultMessage: 'Comment',
    description: 'The text inside of the button that opens up the add comment popup',
  },
  'value-actions.copy-link': {
    id: 'value-actions.copy-link',
    defaultMessage: 'Copy link to value',
    description:
      'The text for the copy link to value button in the contextual dropdown menu.',
  },
  'value-actions.clear-cells': {
    id: 'value-actions.clear-cells',
    defaultMessage: '{valuesCount, plural, one {Clear value} other {Clear values}}',
    description:
      'The text for the clear multiple cells button in the contextual dropdown menu.',
  },
  'value-actions.bulk-edit-values': {
    id: 'value-actions.bulk-edit-values',
    defaultMessage:
      '{valuesCount, plural, one {Edit {valuesCount} value} other {Edit {valuesCount} values}}',
    description:
      'The text for trigger to open the bulk edit values popup in the contextual dropdown menu.',
  },
  'delete-buttons.delete-entry-tooltip': {
    id: 'delete-buttons.delete-entry-tooltip',
    defaultMessage: 'Delete entry',
    description: 'The tooltip on the trashcan icon for deleting an entry.',
  },
  'delete-buttons.delete-field-tooltip': {
    id: 'delete-buttons.delete-field-tooltip',
    defaultMessage: 'Delete field',
    description: 'The tooltip on the trashcan icon for deleting an field.',
  },
  'delete-buttons.minimum-one-entry-tooltip': {
    id: 'delete-buttons.minimum-one-entry-tooltip',
    defaultMessage: 'Database must have at least 1 entry',
    description:
      'The tooltip text indicating that the database must have at least 1 entry when trying to delete a column and no column would be left then.',
  },
  'delete-buttons.delete-field-cancel-button': {
    id: 'delete-buttons.delete-field-cancel-button',
    defaultMessage: 'Cancel',
    description: 'The button text for the cancel button in the delete field dialog.',
  },
  'delete-buttons.delete-field-button': {
    id: 'delete-buttons.delete-field-button',
    defaultMessage: 'Delete',
    description: 'The button text for the delete button in the delete field dialog.',
  },
  'delete-buttons.delete-field': {
    id: 'delete-buttons.delete-field',
    defaultMessage: 'Delete field',
    description: 'The heading and label text for the delete field dialog.',
  },
  'delete-buttons.delete-field-confirmation-message': {
    id: 'delete-buttons.delete-field-confirmation-message',
    defaultMessage:
      'Are you sure you want to delete the field <strong>{fieldName}</strong> from the database? This will delete the field from all entries in the database!',
    description: 'The heading and label text for the delete field dialog.',
  },
  'delete-buttons.default-field-name': {
    id: 'delete-buttons.default-field-name',
    defaultMessage: 'Field name',
    description: 'The default name for a field',
  },
  'databases.ga.spotlight.ok': {
    id: 'databases.ga.spotlight.ok',
    defaultMessage: 'OK',
    description: 'Acknowledgement button for onboarding and changeboarding spotlight',
  },
  'onboarding.board-view-spotlight.title': {
    id: 'onboarding.board-view-spotlight.title',
    defaultMessage: 'Group entries for better focus',
    description:
      'Title for the board view onboarding spotlight shown in the add view menu',
  },
  'onboarding.board-view-spotlight.body': {
    id: 'onboarding.board-view-spotlight.body',
    defaultMessage:
      'Group entries by user and/or tag to visually organize data into swimlanes.',
    description:
      'Body text for the board view onboarding spotlight shown in the add view menu',
  },
  'onboarding.board-view-spotlight.create': {
    id: 'onboarding.board-view-spotlight.create',
    defaultMessage: 'Create a board view',
    description: 'CTA button to create a board view from the onboarding spotlight',
  },
  'field-settings.type-page-link-page-sub-type': {
    id: 'field-settings.type-page-link-page-sub-type',
    defaultMessage: 'Type',
    description:
      'The label for the select page sub type section in the page link field settings.',
  },
  'field-settings.type-page-link-live-doc-sub-type-description': {
    id: 'field-settings.type-page-link-live-doc-sub-type-description',
    defaultMessage: 'Use live docs for easy collaboration',
    description:
      'The description for the live doc sub type option in the page link field settings.',
  },
  'field-settings.type-page-link-live-doc-sub-type-label': {
    id: 'field-settings.type-page-link-live-doc-sub-type-label',
    defaultMessage: 'Live doc sub type info',
    description:
      'The label for the live doc sub type option tooltip icon in the page link field settings.',
  },
  'field-settings.type-page-link-page-sub-type-description': {
    id: 'field-settings.type-page-link-page-sub-type-description',
    defaultMessage: 'Use pages for publishing and sharing content',
    description:
      'The description for the page sub type option in the page link field settings.',
  },
  'field-settings.type-page-link-page-sub-type-label': {
    id: 'field-settings.type-page-link-page-sub-type-label',
    defaultMessage: 'Page sub type info',
    description:
      'The label for the page sub type option tooltip icon in the page link field settings.',
  },
  'field-settings.type-page-link-page-location': {
    id: 'field-settings.type-page-link-page-location',
    defaultMessage: 'Page location',
    description:
      'The label for the select page location section in the page link field settings.',
  },
  'field-settings.type-page-link-location': {
    id: 'field-settings.type-page-link-location',
    defaultMessage: 'Location',
    description:
      'The label for the select location section in the page link field settings.',
  },
  'field-settings.type-page-link-dynamic-page-location-description': {
    id: 'field-settings.type-page-link-dynamic-page-location-description',
    defaultMessage:
      'New items will be created as child items from wherever you are editing',
    description:
      'The description for the dynamic page location option in the page link field settings.',
  },
  'field-settings.type-page-link-dynamic-page-location-label': {
    id: 'field-settings.type-page-link-dynamic-page-location-label',
    defaultMessage: 'Dynamic page location info',
    description:
      'The label for the dynamic page location option tooltip icon in the page link field settings.',
  },
  'field-settings.type-page-link-dynamic-location-label': {
    id: 'field-settings.type-page-link-dynamic-location-label',
    defaultMessage: 'Dynamic location info',
    description:
      'The label for the dynamic location option tooltip icon in the page link field settings.',
  },
  'field-settings.type-page-link-fixed-page-location-description': {
    id: 'field-settings.type-page-link-fixed-page-location-description',
    defaultMessage:
      'New pages will always be created as child pages of the selected parent item',
    description:
      'The description for the fixed page location option in the page link field settings.',
  },
  'field-settings.type-page-link-fixed-page-and-live-doc-location-description': {
    id: 'field-settings.type-page-link-fixed-page-and-live-doc-location-description',
    defaultMessage:
      'New pages and live docs will always be created as child items of the selected parent item',
    description:
      'The description for the fixed page and live doc location option in the page link field settings.',
  },
  'field-settings.type-page-link-fixed-page-location-label': {
    id: 'field-settings.type-page-link-fixed-page-location-label',
    defaultMessage: 'Fixed page location info',
    description:
      'The label for the fixed page location option tooltip icon in the page link field settings.',
  },
  'field-settings.type-page-link-fixed-location-label': {
    id: 'field-settings.type-page-link-fixed-location-label',
    defaultMessage: 'Fixed location info',
    description:
      'The label for the fixed location option tooltip icon in the page link field settings.',
  },
  'field-settings.type-number-format-percent': {
    id: 'field-settings.type-number-format-percent',
    defaultMessage: 'Percent',
    description:
      'The label for the percent number format option in the number field settings.',
  },
  'field-settings.type-number-format-custom': {
    id: 'field-settings.type-number-format-custom',
    defaultMessage: 'Custom',
    description:
      'The label for the custom number format option in the number field settings.',
  },
  'field-settings.type-number-format-euro': {
    id: 'field-settings.type-number-format-euro',
    defaultMessage: 'Euro',
    description:
      'The label for the euro number format option in the number field settings.',
  },
  'field-settings.type-number-format-dollar': {
    id: 'field-settings.type-number-format-dollar',
    defaultMessage: 'Dollar',
    description:
      'The label for the dollar number format option in the number field settings.',
  },
  'field-settings.type-number-format-currency': {
    id: 'field-settings.type-number-format-currency',
    defaultMessage: 'Currency',
    description:
      'The label for the currency number format option in the number field settings.',
  },
  'field-settings.currency-type-label': {
    id: 'field-settings.currency-type-label',
    defaultMessage: 'Currency type',
    description: 'The label for the currency type dropdown in the number field settings.',
  },
  'field-settings.currency-label-dollar': {
    id: 'field-settings.currency-label-dollar',
    defaultMessage: 'US Dollar ($)',
    description:
      'The label for the Dollar currency type option in the number field settings.',
  },
  'field-settings.currency-label-euro': {
    id: 'field-settings.currency-label-euro',
    defaultMessage: 'Euro (€)',
    description:
      'The label for the Euro currency type option in the number field settings.',
  },
  'field-settings.currency-label-pound': {
    id: 'field-settings.currency-label-pound',
    defaultMessage: 'British Pound (£)',
    description:
      'The label for the Pound currency type option in the number field settings.',
  },
  'field-settings.currency-label-yen': {
    id: 'field-settings.currency-label-yen',
    defaultMessage: 'Japanese Yen (¥)',
    description:
      'The label for the Yen currency type option in the number field settings.',
  },
  'field-settings.currency-label-australian-dollar': {
    id: 'field-settings.currency-label-australian-dollar',
    defaultMessage: 'Australian Dollar (A$)',
    description:
      'The label for the Australian Dollar currency type option in the number field settings.',
  },
  'field-settings.multi-select-grouping-info-label': {
    id: 'field-settings.multi-select-grouping-info-label',
    defaultMessage:
      'Enabling multi-select disables grouping by this field. This may remove grouping in views that use this field.',
    description: 'The information label about grouping for multi select fields',
  },
  'media.full-screen-view': {
    id: 'media.full-screen-view',
    defaultMessage: 'View in fullscreen',
    description: 'The button text for viewing media in full screen',
  },
  'media.add-file': {
    id: 'media.add-file',
    defaultMessage: '{isMulti, plural, one {Add file} other {Add files}}',
    description:
      'Text that shows up when a user can click to add or drag to drop an file into a cell.',
  },
  'media.browse-or-drop-file': {
    id: 'media.browse-or-drop-file',
    defaultMessage: 'Browse or drop file',
    description: 'The button text for adding a file',
  },
  'presence.multiple-users-active.non-final': {
    id: 'presence.multiple-users-active.non-final',
    defaultMessage: '{count, number} others...',
    description:
      'The text for the presence indicator when multiple users are editing the same value.',
  },
  'user-value-value.profile-card-view-profile-label': {
    id: 'user-value-value.profile-card-view-profile-label',
    defaultMessage: 'View Profile',
    description: 'The label for the View Profile CTA in the profile card',
  },
  'comments.view-comment-thread-button-label': {
    id: 'comments.view-comment-thread-button-label',
    defaultMessage: 'View comment thread',
    description: 'The label for the view comment thread button',
  },
  'comments.add-comment-thread-button-label': {
    id: 'comments.add-comment-thread-button-label',
    defaultMessage: 'Add inline comment',
    description: 'The label for the add inline comment button',
  },
  'comments.show-comment-thread-button-tooltip': {
    id: 'comments.show-comment-thread-button-tooltip',
    defaultMessage: '{isMulti, plural, one {Show comment} other {Show comments}}',
    description:
      'The tooltip for the show inline comment thread button with existing comment(s)',
  },
  'hyperlink-value-popover-edit.add-hyperlink-value': {
    id: 'hyperlink-value-popover-edit.add-hyperlink-value',
    defaultMessage: 'Type or paste a link to add',
    description: 'Placeholder text indicating user to add a link',
  },
  'select-picker-popover-edit.createable-placeholder': {
    id: 'select-picker-popover-edit.createable-placeholder',
    defaultMessage: 'Search or create a tag',
    description:
      'The placeholder for the new popover edit select picker when a user is able to search or create a new tag',
  },
  'select-picker-popover-edit.placeholder': {
    id: 'select-picker-popover-edit.placeholder',
    defaultMessage: 'Search for a tag',
    description:
      'The placeholder for the new popover edit select picker when a user is only able to search for an existing tag',
  },
  'jira-issue-picker-popover.search-text': {
    id: 'jira-issue-picker-popover.search-text',
    defaultMessage: 'Search for a Jira issue',
    description:
      'Placeholder text in Jira issue popover picker indicating search for a link',
  },
  'jira-issue-picker-popover.search-text-issue-terminology-refresh-m4': {
    id: 'jira-issue-picker-popover.search-text-issue-terminology-refresh-m4',
    defaultMessage: 'Search for a Jira work item',
    description:
      'Placeholder text in Jira issue popover picker indicating search for a link',
  },
  'user-picker-popover.search-text': {
    id: 'user-picker-popover.search-text',
    defaultMessage: 'Search for a person or team',
    description: 'Placeholder text indicating user to add a link',
  },
  'view.default-view-name': {
    id: 'view.default-view-name:',
    defaultMessage: 'View',
    description:
      'The text for the default view name in the view settings panel. View here is used as a noun.',
  },
  'page-link-picker-popover.search-create-text': {
    id: 'page-link-picker-popover.search-create-text',
    defaultMessage: 'Search or create a page',
    description:
      'Placeholder text in page link popover picker indicating search for a link or create one',
  },
  'page-link-picker-popover.search-text': {
    id: 'page-link-picker-popover.search-text',
    defaultMessage: 'Search for a page',
    description:
      'Placeholder text in page link popover picker indicating search for a link',
  },
  'generic.page-picker.menu.option.description.last-updated': {
    id: 'generic.page-picker.menu.option.description.last-updated',
    defaultMessage: 'Updated {date}',
    description: 'The description for the page picker option.',
  },
  'page-status-picker-popover.search-create-text': {
    id: 'page-status-picker-popover.search-create-text',
    defaultMessage: 'Search or create a status',
    description:
      'Placeholder text in page status popover picker indicating search for a status or create one',
  },
  'page-labels-picker-popover.search-create-text': {
    id: 'page-labels-picker-popover.search-create-text',
    defaultMessage: 'Search or create a label',
    description:
      'Placeholder text in page labels popover picker indicating search for a label or create one',
  },
  'select-field-settings.placeholder-tag-label': {
    id: 'select-field-settings.placeholder-tag-label',
    defaultMessage: 'Tag {number}',
    description:
      'The default tag label for new tags created from the field settings panel.',
  },
  'jira-priority.placeholder': {
    id: 'jira-priority.placeholder',
    defaultMessage: 'Search priorities...',
    description: 'Placeholder text for Jira priority search field',
  },
  'jira-priority.no-options': {
    id: 'jira-priority.no-options',
    defaultMessage: 'No priorities found',
    description: 'Message when no priority options are available',
  },
  'jira-priority.update-failed': {
    id: 'jira-priority-update-failed',
    defaultMessage: 'Failed to update priority',
    description: 'Error message when priority update fails',
  },
  'jira-priority.unknown-priority': {
    id: 'jira-priority-unknown-priority',
    defaultMessage: 'Unknown Priority',
    description: 'Default text when a Jira priority cannot be determined',
  },
  'jira-assignee.placeholder.non-final': {
    id: 'jira-assignee.placeholder.non-final',
    defaultMessage: 'Search assignees...',
    description: 'Placeholder text for Jira assignee search field',
  },
  'jira-assignee.unassigned.label': {
    id: 'jira-assignee.unassigned.label',
    defaultMessage: 'Unassigned',
    description: 'Assignee label for Jira work item without an assignee',
  },
  'jira-assignee.no-options.non-final': {
    id: 'jira-assignee.no-options.non-final',
    defaultMessage: 'No assignees found',
    description: 'Message when no assignee options are available',
  },
  'jira-assignee.update-failed.non-final': {
    id: 'jira-assignee.update-failed.non-final',
    defaultMessage: 'Failed to update assignee',
    description: 'Error message when assignee update fails',
  },
  'jira-assignee.unknown-user.non-final': {
    id: 'jira-assignee.unknown-user.non-final',
    defaultMessage: 'Unknown User',
    description: 'Default text when a Jira assignee cannot be determined',
  },
  'jira-badge.synced-to-jira': {
    id: 'jira-badge.synced-to-jira',
    defaultMessage: 'Changes will be synced to Jira',
    description: 'Tooltip for Jira badge on editable fields',
  },
  'jira-badge.editable-in-jira-only': {
    id: 'jira-badge.editable-in-jira-only',
    defaultMessage: 'Data is only editable in Jira',
    description: 'Tooltip for Jira badge on read-only fields',
  },
  'field-type-icon.two-way-synced': {
    id: 'field-type-icon.two-way-synced',
    defaultMessage: 'Two-way synced with {source}',
    description:
      'Tooltip for field type icon when the field is two-way synced with an external source',
  },
  'field-type-icon.sourced-from': {
    id: 'field-type-icon.sourced-from',
    defaultMessage: 'Sourced from {source}',
    description:
      'Tooltip for field type icon when the field is one-way synced from an external source',
  },
  'field-type-icon.two-way-synced-with-confluence': {
    id: 'field-type-icon.two-way-synced-with-confluence',
    defaultMessage: 'Two-way synced with a page',
    description:
      'Tooltip for field type icon when the field is two-way synced with a confluence page or live doc',
  },
  'field-type-icon.sourced-from-confluence': {
    id: 'field-type-icon.sourced-from-confluence',
    defaultMessage: 'Sourced from a page',
    description:
      'Tooltip for field type icon when the field is one-way synced from a confluence page or live doc',
  },
  'field-type-icon.sourced-from-database': {
    id: 'field-type-icon.sourced-from-database',
    defaultMessage: 'Sourced from another database',
    description:
      'Tooltip for field type icon when the field is one-way synced from another database',
  },
  'fullscreen.open-fullscreen': {
    id: 'fullscreen.open-fullscreen',
    defaultMessage: 'Full screen preview',
    description:
      'Tooltip label for the button that opens fullscreen mode in the database embed toolbar.',
  },
  'fullscreen.close-fullscreen': {
    id: 'fullscreen.close-fullscreen',
    defaultMessage: 'Exit full screen',
    description:
      'Tooltip label for the button that closes fullscreen mode in the database embed toolbar.',
  },
  'rich-text-formatting-toolbar.ask-rovo': {
    id: 'rich-text-formatting-toolbar.ask-rovo',
    defaultMessage: 'Ask Rovo',
    description: 'The label for the Ask Rovo button on the rich text formatting toolbar.',
  },
  'rich-text-formatting-toolbar.shift': {
    id: 'rich-text-formatting-toolbar.shift',
    defaultMessage: 'Shift',
    description:
      'Modifier key for keyboard shortcuts. Please translate to the appropriate abbreviation for the Shift key if it exists in the locale (e.g. Maiusc, Mayús, Maj, Vaihto), else leave as Shift.',
  },
  'rich-text-formatting-toolbar.bold': {
    id: 'rich-text-formatting-toolbar.bold',
    defaultMessage: 'Bold',
    description:
      'Button label on the rich text formatting toolbar. Applies bold formatting to selected text.',
  },
  'rich-text-formatting-toolbar.more-text-styles': {
    id: 'rich-text-formatting-toolbar.more-text-styles',
    defaultMessage: 'More text styles',
    description:
      'The label for the more text styles dropdown button on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.italic': {
    id: 'rich-text-formatting-toolbar.italic',
    defaultMessage: 'Italic',
    description:
      'Button label on the rich text formatting toolbar. Applies italic formatting to selected text.',
  },
  'rich-text-formatting-toolbar.underline': {
    id: 'rich-text-formatting-toolbar.underline',
    defaultMessage: 'Underline',
    description:
      'Button label on the rich text formatting toolbar. Applies underline formatting to selected text.',
  },
  'rich-text-formatting-toolbar.strikethrough': {
    id: 'rich-text-formatting-toolbar.strikethrough',
    defaultMessage: 'Strikethrough',
    description:
      'Button label on the rich text formatting toolbar. Applies strikethrough formatting to selected text.',
  },
  'rich-text-formatting-toolbar.code': {
    id: 'rich-text-formatting-toolbar.code',
    defaultMessage: 'Code',
    description:
      'Button label on the rich text formatting toolbar. Applies inline code formatting to selected text.',
  },
  'rich-text-formatting-toolbar.subscript': {
    id: 'rich-text-formatting-toolbar.subscript',
    defaultMessage: 'Subscript',
    description:
      'Button label on the rich text formatting toolbar. Applies subscript formatting to selected text.',
  },
  'rich-text-formatting-toolbar.superscript': {
    id: 'rich-text-formatting-toolbar.superscript',
    defaultMessage: 'Superscript',
    description:
      'Button label on the rich text formatting toolbar. Applies superscript formatting to selected text.',
  },
  'rich-text-formatting-toolbar.clear-formatting': {
    id: 'rich-text-formatting-toolbar.clear-formatting',
    defaultMessage: 'Clear formatting',
    description: 'The label for the clear formatting button on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.bullet-list': {
    id: 'rich-text-formatting-toolbar.bullet-list',
    defaultMessage: 'Bullet list',
    description: 'The label for the bullet list button on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.more-list-options': {
    id: 'rich-text-formatting-toolbar.more-list-options',
    defaultMessage: 'More list options',
    description:
      'The label for the more list options dropdown button on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.bulleted-list': {
    id: 'rich-text-formatting-toolbar.bulleted-list',
    defaultMessage: 'Bulleted list',
    description: 'The label for the bulleted list menu item on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.numbered-list': {
    id: 'rich-text-formatting-toolbar.numbered-list',
    defaultMessage: 'Numbered list',
    description: 'The label for the numbered list menu item on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.text-color': {
    id: 'rich-text-formatting-toolbar.text-color',
    defaultMessage: 'Text color',
    description: 'The label for the text color button on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.highlight-color': {
    id: 'rich-text-formatting-toolbar.highlight-color',
    defaultMessage: 'Highlight color',
    description: 'The label for the highlight color section in the color picker.',
  },
  'rich-text-formatting-toolbar.remove-color': {
    id: 'rich-text-formatting-toolbar.remove-color',
    defaultMessage: 'Remove color',
    description: 'Button label to remove text and highlight colors from the selection.',
  },
  'rich-text-formatting-toolbar.link': {
    id: 'rich-text-formatting-toolbar.link',
    defaultMessage: 'Link',
    description:
      'Button label on the rich text formatting toolbar. Inserts or edits a hyperlink.',
  },
  'rich-text-formatting-toolbar.format-text': {
    id: 'rich-text-formatting-toolbar.format-text',
    defaultMessage: 'Format text',
    description:
      'Tooltip for the text formatting dropdown trigger on the rich text toolbar.',
  },
  'rich-text-formatting-toolbar.lists': {
    id: 'rich-text-formatting-toolbar.lists',
    defaultMessage: 'Lists',
    description:
      'Tooltip shown on hover over the chevron-down button (next to the bullet list icon) in the databases rich text formatting toolbar. The button opens a dropdown with bulleted list and numbered list options.',
  },
  'rich-text-formatting-toolbar.text-and-highlight-color': {
    id: 'rich-text-formatting-toolbar.text-and-highlight-color',
    defaultMessage: 'Text and highlight color',
    description: 'Tooltip for the color picker button on the rich text toolbar.',
  },
  'table-layout.entry-hidden-by-filters.title': {
    id: 'table-layout.entry-hidden-by-filters.title',
    defaultMessage: 'Entry successfully created',
    description: 'Title of the flag shown when a new entry is hidden by active filters.',
  },
  'table-layout.entry-hidden-by-filters.description': {
    id: 'table-layout.entry-hidden-by-filters.description',
    defaultMessage:
      'Your entry was created, but filters prevent it from showing in this view.',
    description:
      'Description of the flag shown when a new entry is hidden by active filters.',
  },
  'table-layout.entry-hidden-by-filters.show-entry': {
    id: 'table-layout.entry-hidden-by-filters.show-entry',
    defaultMessage: 'Show filtered entry',
    description:
      'Action button label on the flag to open the entry panel for a filtered entry.',
  },
});
